var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _path3, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _path4, _path5, _path6, _path7, _path8, _path9, _rect562, _path0, _path1, _path10, _rect563, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect564, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _rect565, _path52, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path63, _g38, _g39, _path64, _path65, _g40, _g41, _path66, _path67, _path68, _g42, _g43, _path69, _g44, _path70, _g45, _g46, _path71, _g47, _rect566, _g48, _path72, _g49, _g50, _g51, _g52, _g53, _g54, _path73, _g55, _g56, _g57, _g58, _g59, _g60, _path74, _g61, _path75, _path76, _path77, _path78, _path79, _line, _line2, _line3, _line4, _path80, _path81, _path82, _path83, _path84, _line5, _line6, _line7, _line8, _path85, _g62, _path86, _path87, _path88, _g63, _g64, _path89, _path90, _path91, _path92, _path93, _g65, _g66, _path94, _path95, _path96, _path97, _g67, _path98, _g68, _path99, _g69, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g70, _path114, _path115, _g71, _path116, _path117, _path118, _g72, _g73, _g74, _path119, _g75, _path120, _path121, _path122, _g76, _path123, _path124, _path125, _g77, _path126, _g78, _path127, _path128, _path129, _g79, _g80, _path130, _g81, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g82, _g83, _path146, _path147, _g84, _g85, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _g86, _path155, _rect567, _rect568, _rect569, _g87, _path156, _path157, _path158, _g88, _path159, _path160, _g89, _g90, _path161, _g91, _path162;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_786",
    "data-name": "Group 786",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 726.648,
    height: 541.511,
    viewBox: "0 0 726.648 541.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 726.648,
    height: 541.511,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 30.252,
    height: 30.252,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 2.767,
    height: 3.18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 2.821,
    height: 3.175,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 25.822,
    height: 25.821,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 19.951,
    height: 19.952,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1204",
    "data-name": "Rectangle 1204",
    width: 1.594,
    height: 2.219,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1205",
    "data-name": "Rectangle 1205",
    width: 1.622,
    height: 2.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1206",
    "data-name": "Rectangle 1206",
    width: 17.03,
    height: 17.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1209",
    "data-name": "Rectangle 1209",
    width: 2.769,
    height: 3.181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    width: 2.819,
    height: 3.176,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 25.821,
    height: 25.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 19.952,
    height: 19.952,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 1.622,
    height: 2.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 1.176,
    height: 1.453,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 1.202,
    height: 1.447,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 2.551,
    height: 3.325,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 2.588,
    height: 3.32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 0.94,
    height: 1.55,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 0.968,
    height: 1.541,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 23.689,
    height: 23.689,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 13.587,
    height: 13.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1227",
    "data-name": "Rectangle 1227",
    width: 11.599,
    height: 11.597,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 1.296,
    height: 1.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    width: 1.539,
    height: 1.891,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    width: 13.587,
    height: 13.587,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1232",
    "data-name": "Rectangle 1232",
    width: 11.599,
    height: 11.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1233",
    "data-name": "Rectangle 1233",
    width: 1.296,
    height: 1.489,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1234",
    "data-name": "Rectangle 1234",
    width: 1.539,
    height: 1.892,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1235",
    "data-name": "Rectangle 1235",
    width: 35.716,
    height: 44.507,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1236",
    "data-name": "Rectangle 1236",
    width: 16.99,
    height: 31.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 35.716,
    height: 44.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 56.69,
    height: 56.633,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1239",
    "data-name": "Rectangle 1239",
    width: 48.815,
    height: 48.815,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 20.643,
    height: 23.456,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 42.75,
    height: 45.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 24.436,
    height: 23.064,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 22.183,
    height: 37.524,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1244",
    "data-name": "Rectangle 1244",
    width: 38.896,
    height: 38.113,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1245",
    "data-name": "Rectangle 1245",
    width: 4.512,
    height: 4.508,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1248",
    "data-name": "Rectangle 1248",
    width: 29.99,
    height: 13.032,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1249",
    "data-name": "Rectangle 1249",
    width: 45.936,
    height: 46.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 38.55,
    height: 28.618,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1251",
    "data-name": "Rectangle 1251",
    width: 34.302,
    height: 18.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1252",
    "data-name": "Rectangle 1252",
    width: 11.228,
    height: 5.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1253",
    "data-name": "Rectangle 1253",
    width: 11.23,
    height: 22.587,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1254",
    "data-name": "Rectangle 1254",
    width: 11.228,
    height: 18.884,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1255",
    "data-name": "Rectangle 1255",
    width: 67.27,
    height: 53.894,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1259",
    "data-name": "Rectangle 1259",
    width: 11.23,
    height: 37.768,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1261",
    "data-name": "Rectangle 1261",
    width: 69.613,
    height: 3.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 47.901,
    height: 48.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 7.274,
    height: 11.304,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1264",
    "data-name": "Rectangle 1264",
    width: 8.654,
    height: 24.139,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1265",
    "data-name": "Rectangle 1265",
    width: 58.422,
    height: 213.532,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1266",
    "data-name": "Rectangle 1266",
    width: 12.152,
    height: 51.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1267",
    "data-name": "Rectangle 1267",
    width: 43.292,
    height: 217.802,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    width: 58.12,
    height: 87.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1269",
    "data-name": "Rectangle 1269",
    width: 7.999,
    height: 9.945,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 27.206,
    height: 106.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1271",
    "data-name": "Rectangle 1271",
    width: 20.021,
    height: 102.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1272",
    "data-name": "Rectangle 1272",
    width: 14.783,
    height: 10.57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1273",
    "data-name": "Rectangle 1273",
    width: 14.571,
    height: 13.414,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1274",
    "data-name": "Rectangle 1274",
    width: 30.926,
    height: 22.119,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1275",
    "data-name": "Rectangle 1275",
    width: 41.146,
    height: 61.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    width: 7.422,
    height: 10.98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 14.619,
    height: 10.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 31.47,
    height: 103.437,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 60.257,
    height: 85.197,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    width: 25.014,
    height: 61.021,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1281",
    "data-name": "Rectangle 1281",
    width: 9.138,
    height: 11.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1282",
    "data-name": "Rectangle 1282",
    width: 12.193,
    height: 15.912,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1283",
    "data-name": "Rectangle 1283",
    width: 22.185,
    height: 19.268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    width: 14.222,
    height: 21.515,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1285",
    "data-name": "Rectangle 1285",
    width: 12.638,
    height: 18.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1286",
    "data-name": "Rectangle 1286",
    width: 11.18,
    height: 68.827,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1290",
    "data-name": "Rectangle 1290",
    width: 62.579,
    height: 25.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1291",
    "data-name": "Rectangle 1291",
    width: 30.846,
    height: 46.568,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    width: 16.095,
    height: 49.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    width: 66.353,
    height: 54.077,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 11.212,
    height: 12.247,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 726.648,
    height: 0.363,
    transform: "translate(0 475.876)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 48.136,
    height: 0.363,
    transform: "translate(605.703 499.268)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 12.633,
    height: 0.363,
    transform: "translate(468.727 503.211)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 27.892,
    height: 0.363,
    transform: "translate(576.357 485.773)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 62.772,
    height: 0.363,
    transform: "translate(76.238 488.214)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 9.204,
    height: 0.363,
    transform: "translate(151.951 488.214)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 136.139,
    height: 0.362,
    transform: "translate(191.066 494.352)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M327.132,411.06H46.5a8.3,8.3,0,0,1-8.3-8.3V8.3A8.306,8.306,0,0,1,46.5,0h280.63a8.305,8.305,0,0,1,8.294,8.3V402.765a8.3,8.3,0,0,1-8.294,8.3M46.5.363A7.94,7.94,0,0,0,38.57,8.3V402.765A7.94,7.94,0,0,0,46.5,410.7h280.63a7.941,7.941,0,0,0,7.931-7.932V8.3A7.941,7.941,0,0,0,327.132.363Z",
    transform: "translate(17.319)",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M543.429,411.06H262.8a8.3,8.3,0,0,1-8.294-8.3V8.3A8.3,8.3,0,0,1,262.8,0h280.63a8.306,8.306,0,0,1,8.3,8.3V402.765a8.3,8.3,0,0,1-8.3,8.3M262.8.363A7.94,7.94,0,0,0,254.868,8.3V402.765A7.94,7.94,0,0,0,262.8,410.7h280.63a7.941,7.941,0,0,0,7.932-7.932V8.3A7.941,7.941,0,0,0,543.429.363Z",
    transform: "translate(115.366)",
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 347.37,
    height: 286.827,
    transform: "translate(178.213 101.86)",
    fill: "#f5f5f5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 341.795,
    height: 274.905,
    transform: "translate(178.213 107.941)",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M461.9,264.308V167.181H451.807V154.353l-22.7-10.621V130.6h-3.784v36.581h-3.783v97.127h-5.046V213.852H405.136V187.363h-3.784v76.945h-8.829V235.3h-6.307v-7.569H372.339V201.238h-7.567V183.579h-8.83V157.09h-3.784v26.489h-8.829v17.659H335.76v26.489H321.884V235.3h-6.306v29.012h-7.569V227.727H294.133V147H290.35v-8.83H260.077V147h-6.307v58.023H228.542v6.307h-8.83v3.784h8.83v22.7H202.052V162.135h-5.046V147H184.393V88.975h-3.784V147h-8.83v15.136H122.627V342.514H464.422V264.308Z",
    transform: "translate(55.586 40.332)",
    fill: "#f0f0f0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 206.423)",
    fill: "#f5f5f5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 212.414)",
    fill: "#f5f5f5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 236.38)",
    fill: "#f5f5f5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 242.372)",
    fill: "#f5f5f5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 248.364)",
    fill: "#f5f5f5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 266.338)",
    fill: "#f5f5f5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 3.574,
    height: 3.574,
    transform: "translate(204.477 272.33)",
    fill: "#f5f5f5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 230.389)",
    fill: "#f5f5f5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 236.38)",
    fill: "#f5f5f5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 242.372)",
    fill: "#f5f5f5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 248.364)",
    fill: "#f5f5f5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 254.356)",
    fill: "#f5f5f5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 266.338)",
    fill: "#f5f5f5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 3.574,
    height: 3.574,
    transform: "translate(210.154 272.33)",
    fill: "#f5f5f5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 206.423)",
    fill: "#f5f5f5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 212.414)",
    fill: "#f5f5f5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 218.406)",
    fill: "#f5f5f5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 224.398)",
    fill: "#f5f5f5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 230.389)",
    fill: "#f5f5f5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 236.38)",
    fill: "#f5f5f5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 242.372)",
    fill: "#f5f5f5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 248.364)",
    fill: "#f5f5f5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 254.356)",
    fill: "#f5f5f5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 260.346)",
    fill: "#f5f5f5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 3.574,
    height: 3.574,
    transform: "translate(215.83 272.33)",
    fill: "#f5f5f5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 206.423)",
    fill: "#f5f5f5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 212.414)",
    fill: "#f5f5f5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 218.406)",
    fill: "#f5f5f5"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 224.398)",
    fill: "#f5f5f5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 230.389)",
    fill: "#f5f5f5"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 236.38)",
    fill: "#f5f5f5"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 242.372)",
    fill: "#f5f5f5"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 3.574,
    height: 3.574,
    transform: "translate(221.505 296.296)",
    fill: "#f5f5f5"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 206.423)",
    fill: "#f5f5f5"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 212.414)",
    fill: "#f5f5f5"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 218.406)",
    fill: "#f5f5f5"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 224.398)",
    fill: "#f5f5f5"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 230.389)",
    fill: "#f5f5f5"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 236.38)",
    fill: "#f5f5f5"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 242.372)",
    fill: "#f5f5f5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 248.364)",
    fill: "#f5f5f5"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 284.314)",
    fill: "#f5f5f5"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 290.304)",
    fill: "#f5f5f5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 296.296)",
    fill: "#f5f5f5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 302.288)",
    fill: "#f5f5f5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 3.574,
    height: 3.574,
    transform: "translate(227.182 326.255)",
    fill: "#f5f5f5"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 206.423)",
    fill: "#f5f5f5"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 212.414)",
    fill: "#f5f5f5"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 218.406)",
    fill: "#f5f5f5"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 224.398)",
    fill: "#f5f5f5"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 230.389)",
    fill: "#f5f5f5"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 236.38)",
    fill: "#f5f5f5"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 242.372)",
    fill: "#f5f5f5"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 248.364)",
    fill: "#f5f5f5"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 254.356)",
    fill: "#f5f5f5"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 260.346)",
    fill: "#f5f5f5"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 278.322)",
    fill: "#f5f5f5"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 284.314)",
    fill: "#f5f5f5"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 290.304)",
    fill: "#f5f5f5"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 296.296)",
    fill: "#f5f5f5"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 302.288)",
    fill: "#f5f5f5"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 3.574,
    height: 3.574,
    transform: "translate(232.859 326.255)",
    fill: "#f5f5f5"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 206.423)",
    fill: "#f5f5f5"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 212.414)",
    fill: "#f5f5f5"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 218.406)",
    fill: "#f5f5f5"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 224.398)",
    fill: "#f5f5f5"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 230.389)",
    fill: "#f5f5f5"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 236.38)",
    fill: "#f5f5f5"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 242.372)",
    fill: "#f5f5f5"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 248.364)",
    fill: "#f5f5f5"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 254.356)",
    fill: "#f5f5f5"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 260.346)",
    fill: "#f5f5f5"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 266.338)",
    fill: "#f5f5f5"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 272.33)",
    fill: "#f5f5f5"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 278.322)",
    fill: "#f5f5f5"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 284.314)",
    fill: "#f5f5f5"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 290.304)",
    fill: "#f5f5f5"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 296.296)",
    fill: "#f5f5f5"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 302.288)",
    fill: "#f5f5f5"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 3.574,
    height: 3.574,
    transform: "translate(238.535 308.28)",
    fill: "#f5f5f5"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 206.423)",
    fill: "#f5f5f5"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 212.414)",
    fill: "#f5f5f5"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 218.406)",
    fill: "#f5f5f5"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 224.398)",
    fill: "#f5f5f5"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 230.389)",
    fill: "#f5f5f5"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 236.38)",
    fill: "#f5f5f5"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 242.372)",
    fill: "#f5f5f5"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 248.364)",
    fill: "#f5f5f5"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 254.356)",
    fill: "#f5f5f5"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 260.346)",
    fill: "#f5f5f5"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 278.322)",
    fill: "#f5f5f5"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 284.314)",
    fill: "#f5f5f5"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 290.304)",
    fill: "#f5f5f5"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 3.574,
    height: 3.574,
    transform: "translate(244.21 296.296)",
    fill: "#f5f5f5"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 206.423)",
    fill: "#f5f5f5"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 212.414)",
    fill: "#f5f5f5"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 218.406)",
    fill: "#f5f5f5"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 224.398)",
    fill: "#f5f5f5"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 230.389)",
    fill: "#f5f5f5"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 236.38)",
    fill: "#f5f5f5"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 242.372)",
    fill: "#f5f5f5"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 248.364)",
    fill: "#f5f5f5"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 254.356)",
    fill: "#f5f5f5"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 260.346)",
    fill: "#f5f5f5"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 278.322)",
    fill: "#f5f5f5"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 284.314)",
    fill: "#f5f5f5"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 3.574,
    height: 3.574,
    transform: "translate(249.887 290.304)",
    fill: "#f5f5f5"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_746",
    "data-name": "Rectangle 746",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 190.866)",
    fill: "#f5f5f5"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 196.858)",
    fill: "#f5f5f5"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 202.848)",
    fill: "#f5f5f5"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 208.84)",
    fill: "#f5f5f5"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 214.832)",
    fill: "#f5f5f5"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 220.824)",
    fill: "#f5f5f5"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 226.814)",
    fill: "#f5f5f5"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 232.806)",
    fill: "#f5f5f5"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 250.782)",
    fill: "#f5f5f5"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 3.574,
    height: 3.574,
    transform: "translate(313.797 256.773)",
    fill: "#f5f5f5"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 190.866)",
    fill: "#f5f5f5"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 196.858)",
    fill: "#f5f5f5"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 202.848)",
    fill: "#f5f5f5"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 208.84)",
    fill: "#f5f5f5"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 214.832)",
    fill: "#f5f5f5"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 220.824)",
    fill: "#f5f5f5"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 226.814)",
    fill: "#f5f5f5"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 232.806)",
    fill: "#f5f5f5"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 3.574,
    height: 3.574,
    transform: "translate(319.474 256.773)",
    fill: "#f5f5f5"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 190.866)",
    fill: "#f5f5f5"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 196.858)",
    fill: "#f5f5f5"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 202.848)",
    fill: "#f5f5f5"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 208.84)",
    fill: "#f5f5f5"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 214.832)",
    fill: "#f5f5f5"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 220.824)",
    fill: "#f5f5f5"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 226.814)",
    fill: "#f5f5f5"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 3.574,
    height: 3.574,
    transform: "translate(325.15 232.806)",
    fill: "#f5f5f5"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 190.866)",
    fill: "#f5f5f5"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 196.858)",
    fill: "#f5f5f5"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 202.848)",
    fill: "#f5f5f5"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 208.84)",
    fill: "#f5f5f5"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 214.832)",
    fill: "#f5f5f5"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 220.824)",
    fill: "#f5f5f5"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 232.806)",
    fill: "#f5f5f5"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 238.798)",
    fill: "#f5f5f5"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 256.773)",
    fill: "#f5f5f5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 262.765)",
    fill: "#f5f5f5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 268.757)",
    fill: "#f5f5f5"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 274.748)",
    fill: "#f5f5f5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 280.739)",
    fill: "#f5f5f5"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 286.731)",
    fill: "#f5f5f5"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 3.574,
    height: 3.574,
    transform: "translate(330.827 292.723)",
    fill: "#f5f5f5"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 190.866)",
    fill: "#f5f5f5"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 196.858)",
    fill: "#f5f5f5"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 202.848)",
    fill: "#f5f5f5"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 208.84)",
    fill: "#f5f5f5"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 214.832)",
    fill: "#f5f5f5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 220.824)",
    fill: "#f5f5f5"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 238.798)",
    fill: "#f5f5f5"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 244.79)",
    fill: "#f5f5f5"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 250.782)",
    fill: "#f5f5f5"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 256.773)",
    fill: "#f5f5f5"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 262.765)",
    fill: "#f5f5f5"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 268.757)",
    fill: "#f5f5f5"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 274.748)",
    fill: "#f5f5f5"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 280.739)",
    fill: "#f5f5f5"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 286.731)",
    fill: "#f5f5f5"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 292.723)",
    fill: "#f5f5f5"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 298.715)",
    fill: "#f5f5f5"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 3.574,
    height: 3.574,
    transform: "translate(336.502 310.697)",
    fill: "#f5f5f5"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 190.866)",
    fill: "#f5f5f5"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 196.858)",
    fill: "#f5f5f5"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 202.848)",
    fill: "#f5f5f5"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 208.84)",
    fill: "#f5f5f5"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 214.832)",
    fill: "#f5f5f5"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 220.824)",
    fill: "#f5f5f5"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 238.798)",
    fill: "#f5f5f5"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 244.79)",
    fill: "#f5f5f5"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 250.782)",
    fill: "#f5f5f5"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 256.773)",
    fill: "#f5f5f5"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 274.748)",
    fill: "#f5f5f5"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 280.739)",
    fill: "#f5f5f5"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 286.731)",
    fill: "#f5f5f5"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 292.723)",
    fill: "#f5f5f5"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 298.715)",
    fill: "#f5f5f5"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 310.697)",
    fill: "#f5f5f5"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 3.574,
    height: 3.574,
    transform: "translate(342.178 316.689)",
    fill: "#f5f5f5"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_823",
    "data-name": "Rectangle 823",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 246.576)",
    fill: "#f5f5f5"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 252.568)",
    fill: "#f5f5f5"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 258.56)",
    fill: "#f5f5f5"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 264.552)",
    fill: "#f5f5f5"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 270.543)",
    fill: "#f5f5f5"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 276.535)",
    fill: "#f5f5f5"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 282.526)",
    fill: "#f5f5f5"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 300.501)",
    fill: "#f5f5f5"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 306.493)",
    fill: "#f5f5f5"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 3.574,
    height: 3.574,
    transform: "translate(393.686 312.485)",
    fill: "#f5f5f5"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 246.576)",
    fill: "#f5f5f5"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 252.568)",
    fill: "#f5f5f5"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 258.56)",
    fill: "#f5f5f5"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 264.552)",
    fill: "#f5f5f5"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 270.543)",
    fill: "#f5f5f5"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 276.535)",
    fill: "#f5f5f5"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 3.574,
    height: 3.574,
    transform: "translate(399.363 282.526)",
    fill: "#f5f5f5"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 246.576)",
    fill: "#f5f5f5"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 252.568)",
    fill: "#f5f5f5"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 258.56)",
    fill: "#f5f5f5"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 264.552)",
    fill: "#f5f5f5"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 270.543)",
    fill: "#f5f5f5"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 276.535)",
    fill: "#f5f5f5"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 3.574,
    height: 3.574,
    transform: "translate(405.038 282.526)",
    fill: "#f5f5f5"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 246.576)",
    fill: "#f5f5f5"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 252.568)",
    fill: "#f5f5f5"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 258.56)",
    fill: "#f5f5f5"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 264.552)",
    fill: "#f5f5f5"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 270.543)",
    fill: "#f5f5f5"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 276.535)",
    fill: "#f5f5f5"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 282.526)",
    fill: "#f5f5f5"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 288.518)",
    fill: "#f5f5f5"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 294.509)",
    fill: "#f5f5f5"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 300.501)",
    fill: "#f5f5f5"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 3.574,
    height: 3.574,
    transform: "translate(410.714 306.493)",
    fill: "#f5f5f5"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 246.576)",
    fill: "#f5f5f5"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 252.568)",
    fill: "#f5f5f5"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 258.56)",
    fill: "#f5f5f5"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 264.552)",
    fill: "#f5f5f5"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 270.543)",
    fill: "#f5f5f5"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 276.535)",
    fill: "#f5f5f5"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 282.526)",
    fill: "#f5f5f5"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 288.518)",
    fill: "#f5f5f5"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 294.509)",
    fill: "#f5f5f5"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 300.501)",
    fill: "#f5f5f5"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 306.493)",
    fill: "#f5f5f5"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 312.485)",
    fill: "#f5f5f5"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 330.459)",
    fill: "#f5f5f5"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 3.574,
    height: 3.574,
    transform: "translate(416.391 336.451)",
    fill: "#f5f5f5"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 246.576)",
    fill: "#f5f5f5"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 252.568)",
    fill: "#f5f5f5"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 258.56)",
    fill: "#f5f5f5"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 276.535)",
    fill: "#f5f5f5"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 282.526)",
    fill: "#f5f5f5"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 288.518)",
    fill: "#f5f5f5"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 294.509)",
    fill: "#f5f5f5"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 300.501)",
    fill: "#f5f5f5"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 306.493)",
    fill: "#f5f5f5"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 312.485)",
    fill: "#f5f5f5"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 330.459)",
    fill: "#f5f5f5"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 336.451)",
    fill: "#f5f5f5"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 3.574,
    height: 3.574,
    transform: "translate(422.068 342.443)",
    fill: "#f5f5f5"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 210.628)",
    fill: "#f5f5f5"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 216.62)",
    fill: "#f5f5f5"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 222.61)",
    fill: "#f5f5f5"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 228.602)",
    fill: "#f5f5f5"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 234.594)",
    fill: "#f5f5f5"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 240.586)",
    fill: "#f5f5f5"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 246.576)",
    fill: "#f5f5f5"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 252.568)",
    fill: "#f5f5f5"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 258.56)",
    fill: "#f5f5f5"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 264.552)",
    fill: "#f5f5f5"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 270.543)",
    fill: "#f5f5f5"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 276.535)",
    fill: "#f5f5f5"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 282.526)",
    fill: "#f5f5f5"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 288.518)",
    fill: "#f5f5f5"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 294.509)",
    fill: "#f5f5f5"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 300.501)",
    fill: "#f5f5f5"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 306.493)",
    fill: "#f5f5f5"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_902",
    "data-name": "Rectangle 902",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 312.485)",
    fill: "#f5f5f5"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 318.477)",
    fill: "#f5f5f5"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 324.467)",
    fill: "#f5f5f5"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 330.459)",
    fill: "#f5f5f5"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 336.451)",
    fill: "#f5f5f5"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 3.574,
    height: 3.574,
    transform: "translate(481.563 342.443)",
    fill: "#f5f5f5"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 210.628)",
    fill: "#f5f5f5"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 216.62)",
    fill: "#f5f5f5"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 222.61)",
    fill: "#f5f5f5"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 228.602)",
    fill: "#f5f5f5"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 234.594)",
    fill: "#f5f5f5"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 240.586)",
    fill: "#f5f5f5"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 246.576)",
    fill: "#f5f5f5"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 252.568)",
    fill: "#f5f5f5"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 258.56)",
    fill: "#f5f5f5"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 264.552)",
    fill: "#f5f5f5"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 270.543)",
    fill: "#f5f5f5"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_919",
    "data-name": "Rectangle 919",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 276.535)",
    fill: "#f5f5f5"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 282.526)",
    fill: "#f5f5f5"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 288.518)",
    fill: "#f5f5f5"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 294.509)",
    fill: "#f5f5f5"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 300.501)",
    fill: "#f5f5f5"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 306.493)",
    fill: "#f5f5f5"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 312.485)",
    fill: "#f5f5f5"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 3.574,
    height: 3.574,
    transform: "translate(487.239 318.477)",
    fill: "#f5f5f5"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 210.628)",
    fill: "#f5f5f5"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 216.62)",
    fill: "#f5f5f5"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 222.61)",
    fill: "#f5f5f5"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 228.602)",
    fill: "#f5f5f5"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 234.594)",
    fill: "#f5f5f5"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 240.586)",
    fill: "#f5f5f5"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 246.576)",
    fill: "#f5f5f5"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 252.568)",
    fill: "#f5f5f5"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 258.56)",
    fill: "#f5f5f5"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 264.552)",
    fill: "#f5f5f5"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 270.543)",
    fill: "#f5f5f5"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 276.535)",
    fill: "#f5f5f5"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 282.526)",
    fill: "#f5f5f5"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 288.518)",
    fill: "#f5f5f5"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 294.509)",
    fill: "#f5f5f5"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 300.501)",
    fill: "#f5f5f5"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 306.493)",
    fill: "#f5f5f5"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 312.485)",
    fill: "#f5f5f5"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 3.574,
    height: 3.574,
    transform: "translate(492.916 318.477)",
    fill: "#f5f5f5"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 210.628)",
    fill: "#f5f5f5"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 216.62)",
    fill: "#f5f5f5"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 222.61)",
    fill: "#f5f5f5"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 228.602)",
    fill: "#f5f5f5"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 234.594)",
    fill: "#f5f5f5"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 240.586)",
    fill: "#f5f5f5"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 246.576)",
    fill: "#f5f5f5"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 252.568)",
    fill: "#f5f5f5"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 258.56)",
    fill: "#f5f5f5"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 264.552)",
    fill: "#f5f5f5"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 270.543)",
    fill: "#f5f5f5"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 276.535)",
    fill: "#f5f5f5"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 282.526)",
    fill: "#f5f5f5"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 288.518)",
    fill: "#f5f5f5"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 3.574,
    height: 3.574,
    transform: "translate(498.591 294.509)",
    fill: "#f5f5f5"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 210.628)",
    fill: "#f5f5f5"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 216.62)",
    fill: "#f5f5f5"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 222.61)",
    fill: "#f5f5f5"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_964",
    "data-name": "Rectangle 964",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 228.602)",
    fill: "#f5f5f5"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    "data-name": "Rectangle 965",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 234.594)",
    fill: "#f5f5f5"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 240.586)",
    fill: "#f5f5f5"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 246.576)",
    fill: "#f5f5f5"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 252.568)",
    fill: "#f5f5f5"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 258.56)",
    fill: "#f5f5f5"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 264.552)",
    fill: "#f5f5f5"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 270.543)",
    fill: "#f5f5f5"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 276.535)",
    fill: "#f5f5f5"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 3.574,
    height: 3.574,
    transform: "translate(504.267 282.526)",
    fill: "#f5f5f5"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 210.628)",
    fill: "#f5f5f5"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 216.62)",
    fill: "#f5f5f5"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 222.61)",
    fill: "#f5f5f5"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 228.602)",
    fill: "#f5f5f5"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 234.594)",
    fill: "#f5f5f5"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 240.586)",
    fill: "#f5f5f5"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 246.576)",
    fill: "#f5f5f5"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 252.568)",
    fill: "#f5f5f5"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 258.56)",
    fill: "#f5f5f5"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 264.552)",
    fill: "#f5f5f5"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 270.543)",
    fill: "#f5f5f5"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_985",
    "data-name": "Rectangle 985",
    width: 3.574,
    height: 3.574,
    transform: "translate(509.944 276.535)",
    fill: "#f5f5f5"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 208.84)",
    fill: "#f5f5f5"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 214.832)",
    fill: "#f5f5f5"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 220.824)",
    fill: "#f5f5f5"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 226.814)",
    fill: "#f5f5f5"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 232.806)",
    fill: "#f5f5f5"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 238.798)",
    fill: "#f5f5f5"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 244.79)",
    fill: "#f5f5f5"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 250.782)",
    fill: "#f5f5f5"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 256.773)",
    fill: "#f5f5f5"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 262.765)",
    fill: "#f5f5f5"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 268.757)",
    fill: "#f5f5f5"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_997",
    "data-name": "Rectangle 997",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 274.748)",
    fill: "#f5f5f5"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 280.739)",
    fill: "#f5f5f5"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 286.731)",
    fill: "#f5f5f5"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 292.723)",
    fill: "#f5f5f5"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 298.715)",
    fill: "#f5f5f5"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 304.705)",
    fill: "#f5f5f5"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1003",
    "data-name": "Rectangle 1003",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 316.689)",
    fill: "#f5f5f5"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 322.681)",
    fill: "#f5f5f5"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 328.673)",
    fill: "#f5f5f5"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 334.663)",
    fill: "#f5f5f5"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 3.574,
    height: 3.574,
    transform: "translate(178.619 340.655)",
    fill: "#f5f5f5"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 208.84)",
    fill: "#f5f5f5"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 214.832)",
    fill: "#f5f5f5"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1010",
    "data-name": "Rectangle 1010",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 220.824)",
    fill: "#f5f5f5"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 226.814)",
    fill: "#f5f5f5"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 232.806)",
    fill: "#f5f5f5"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 238.798)",
    fill: "#f5f5f5"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 244.79)",
    fill: "#f5f5f5"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 250.782)",
    fill: "#f5f5f5"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 256.773)",
    fill: "#f5f5f5"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 262.765)",
    fill: "#f5f5f5"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 268.757)",
    fill: "#f5f5f5"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 274.748)",
    fill: "#f5f5f5"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 280.739)",
    fill: "#f5f5f5"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 286.731)",
    fill: "#f5f5f5"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 292.723)",
    fill: "#f5f5f5"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 298.715)",
    fill: "#f5f5f5"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 334.663)",
    fill: "#f5f5f5"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 3.574,
    height: 3.574,
    transform: "translate(184.295 340.655)",
    fill: "#f5f5f5"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 208.84)",
    fill: "#f5f5f5"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 214.832)",
    fill: "#f5f5f5"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 220.824)",
    fill: "#f5f5f5"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1029",
    "data-name": "Rectangle 1029",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 226.814)",
    fill: "#f5f5f5"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 232.806)",
    fill: "#f5f5f5"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 238.798)",
    fill: "#f5f5f5"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 244.79)",
    fill: "#f5f5f5"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 250.782)",
    fill: "#f5f5f5"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1034",
    "data-name": "Rectangle 1034",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 256.773)",
    fill: "#f5f5f5"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 262.765)",
    fill: "#f5f5f5"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 268.757)",
    fill: "#f5f5f5"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 274.748)",
    fill: "#f5f5f5"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    "data-name": "Rectangle 1038",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 280.739)",
    fill: "#f5f5f5"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 286.731)",
    fill: "#f5f5f5"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 292.723)",
    fill: "#f5f5f5"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 298.715)",
    fill: "#f5f5f5"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 310.697)",
    fill: "#f5f5f5"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 316.689)",
    fill: "#f5f5f5"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 322.681)",
    fill: "#f5f5f5"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 328.673)",
    fill: "#f5f5f5"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 3.574,
    height: 3.574,
    transform: "translate(189.972 340.655)",
    fill: "#f5f5f5"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 250.782)",
    fill: "#f5f5f5"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 256.773)",
    fill: "#f5f5f5"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 262.765)",
    fill: "#f5f5f5"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 268.757)",
    fill: "#f5f5f5"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 274.748)",
    fill: "#f5f5f5"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 280.739)",
    fill: "#f5f5f5"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 286.731)",
    fill: "#f5f5f5"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 292.723)",
    fill: "#f5f5f5"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 298.715)",
    fill: "#f5f5f5"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 304.705)",
    fill: "#f5f5f5"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 310.697)",
    fill: "#f5f5f5"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 316.689)",
    fill: "#f5f5f5"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 322.681)",
    fill: "#f5f5f5"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 334.663)",
    fill: "#f5f5f5"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 340.655)",
    fill: "#f5f5f5"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 346.647)",
    fill: "#f5f5f5"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 352.639)",
    fill: "#f5f5f5"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 364.622)",
    fill: "#f5f5f5"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1065",
    "data-name": "Rectangle 1065",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 370.614)",
    fill: "#f5f5f5"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 3.574,
    height: 3.574,
    transform: "translate(288.991 376.606)",
    fill: "#f5f5f5"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 250.782)",
    fill: "#f5f5f5"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 256.773)",
    fill: "#f5f5f5"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 262.765)",
    fill: "#f5f5f5"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 268.757)",
    fill: "#f5f5f5"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 274.748)",
    fill: "#f5f5f5"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 280.739)",
    fill: "#f5f5f5"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 286.731)",
    fill: "#f5f5f5"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 292.723)",
    fill: "#f5f5f5"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 298.715)",
    fill: "#f5f5f5"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 304.705)",
    fill: "#f5f5f5"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 310.697)",
    fill: "#f5f5f5"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1078",
    "data-name": "Rectangle 1078",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 316.689)",
    fill: "#f5f5f5"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 322.681)",
    fill: "#f5f5f5"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 340.655)",
    fill: "#f5f5f5"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 346.647)",
    fill: "#f5f5f5"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 358.63)",
    fill: "#f5f5f5"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 364.622)",
    fill: "#f5f5f5"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 370.614)",
    fill: "#f5f5f5"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 3.574,
    height: 3.574,
    transform: "translate(294.667 376.606)",
    fill: "#f5f5f5"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 250.782)",
    fill: "#f5f5f5"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 256.773)",
    fill: "#f5f5f5"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 262.765)",
    fill: "#f5f5f5"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1089",
    "data-name": "Rectangle 1089",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 268.757)",
    fill: "#f5f5f5"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 274.748)",
    fill: "#f5f5f5"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 280.739)",
    fill: "#f5f5f5"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 286.731)",
    fill: "#f5f5f5"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 292.723)",
    fill: "#f5f5f5"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 298.715)",
    fill: "#f5f5f5"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 304.705)",
    fill: "#f5f5f5"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 310.697)",
    fill: "#f5f5f5"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1097",
    "data-name": "Rectangle 1097",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 316.689)",
    fill: "#f5f5f5"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1098",
    "data-name": "Rectangle 1098",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 322.681)",
    fill: "#f5f5f5"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1099",
    "data-name": "Rectangle 1099",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 328.673)",
    fill: "#f5f5f5"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 340.655)",
    fill: "#f5f5f5"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 352.639)",
    fill: "#f5f5f5"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 358.63)",
    fill: "#f5f5f5"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 364.622)",
    fill: "#f5f5f5"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 370.614)",
    fill: "#f5f5f5"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 3.574,
    height: 3.574,
    transform: "translate(300.342 376.606)",
    fill: "#f5f5f5"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 284.945)",
    fill: "#f5f5f5"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 290.935)",
    fill: "#f5f5f5"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 296.927)",
    fill: "#f5f5f5"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 302.919)",
    fill: "#f5f5f5"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 308.911)",
    fill: "#f5f5f5"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 314.902)",
    fill: "#f5f5f5"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 332.877)",
    fill: "#f5f5f5"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 338.869)",
    fill: "#f5f5f5"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 344.86)",
    fill: "#f5f5f5"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1115",
    "data-name": "Rectangle 1115",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 350.852)",
    fill: "#f5f5f5"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 356.844)",
    fill: "#f5f5f5"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 362.836)",
    fill: "#f5f5f5"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1118",
    "data-name": "Rectangle 1118",
    width: 3.574,
    height: 3.574,
    transform: "translate(265.864 368.826)",
    fill: "#f5f5f5"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 284.945)",
    fill: "#f5f5f5"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 290.935)",
    fill: "#f5f5f5"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 296.927)",
    fill: "#f5f5f5"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1122",
    "data-name": "Rectangle 1122",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 302.919)",
    fill: "#f5f5f5"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 308.911)",
    fill: "#f5f5f5"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1124",
    "data-name": "Rectangle 1124",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 314.902)",
    fill: "#f5f5f5"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 332.877)",
    fill: "#f5f5f5"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 338.869)",
    fill: "#f5f5f5"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 344.86)",
    fill: "#f5f5f5"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 350.852)",
    fill: "#f5f5f5"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 356.844)",
    fill: "#f5f5f5"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 362.836)",
    fill: "#f5f5f5"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 3.574,
    height: 3.574,
    transform: "translate(271.541 374.818)",
    fill: "#f5f5f5"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 258.56)",
    fill: "#f5f5f5"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1133",
    "data-name": "Rectangle 1133",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 264.552)",
    fill: "#f5f5f5"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1134",
    "data-name": "Rectangle 1134",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 270.543)",
    fill: "#f5f5f5"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 276.535)",
    fill: "#f5f5f5"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1136",
    "data-name": "Rectangle 1136",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 282.526)",
    fill: "#f5f5f5"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1137",
    "data-name": "Rectangle 1137",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 288.518)",
    fill: "#f5f5f5"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1138",
    "data-name": "Rectangle 1138",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 294.509)",
    fill: "#f5f5f5"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 300.501)",
    fill: "#f5f5f5"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1140",
    "data-name": "Rectangle 1140",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 306.493)",
    fill: "#f5f5f5"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 312.485)",
    fill: "#f5f5f5"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 318.477)",
    fill: "#f5f5f5"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 330.459)",
    fill: "#f5f5f5"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 336.451)",
    fill: "#f5f5f5"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1145",
    "data-name": "Rectangle 1145",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 342.443)",
    fill: "#f5f5f5"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1146",
    "data-name": "Rectangle 1146",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 348.433)",
    fill: "#f5f5f5"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1147",
    "data-name": "Rectangle 1147",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 354.425)",
    fill: "#f5f5f5"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1148",
    "data-name": "Rectangle 1148",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 360.417)",
    fill: "#f5f5f5"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1149",
    "data-name": "Rectangle 1149",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 366.409)",
    fill: "#f5f5f5"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    width: 3.574,
    height: 3.574,
    transform: "translate(460.119 372.4)",
    fill: "#f5f5f5"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 258.56)",
    fill: "#f5f5f5"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 264.552)",
    fill: "#f5f5f5"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1153",
    "data-name": "Rectangle 1153",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 270.543)",
    fill: "#f5f5f5"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1154",
    "data-name": "Rectangle 1154",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 276.535)",
    fill: "#f5f5f5"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1155",
    "data-name": "Rectangle 1155",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 282.526)",
    fill: "#f5f5f5"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1156",
    "data-name": "Rectangle 1156",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 288.518)",
    fill: "#f5f5f5"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1157",
    "data-name": "Rectangle 1157",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 294.509)",
    fill: "#f5f5f5"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1158",
    "data-name": "Rectangle 1158",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 300.501)",
    fill: "#f5f5f5"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1159",
    "data-name": "Rectangle 1159",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 306.493)",
    fill: "#f5f5f5"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1160",
    "data-name": "Rectangle 1160",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 312.485)",
    fill: "#f5f5f5"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 318.477)",
    fill: "#f5f5f5"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 324.467)",
    fill: "#f5f5f5"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 330.459)",
    fill: "#f5f5f5"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1164",
    "data-name": "Rectangle 1164",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 336.451)",
    fill: "#f5f5f5"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1165",
    "data-name": "Rectangle 1165",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 342.443)",
    fill: "#f5f5f5"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1166",
    "data-name": "Rectangle 1166",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 348.433)",
    fill: "#f5f5f5"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1167",
    "data-name": "Rectangle 1167",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 354.425)",
    fill: "#f5f5f5"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1168",
    "data-name": "Rectangle 1168",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 360.417)",
    fill: "#f5f5f5"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 366.409)",
    fill: "#f5f5f5"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1170",
    "data-name": "Rectangle 1170",
    width: 3.574,
    height: 3.574,
    transform: "translate(465.794 372.4)",
    fill: "#f5f5f5"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1171",
    "data-name": "Rectangle 1171",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 281.896)",
    fill: "#f5f5f5"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1172",
    "data-name": "Rectangle 1172",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 287.888)",
    fill: "#f5f5f5"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1173",
    "data-name": "Rectangle 1173",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 293.88)",
    fill: "#f5f5f5"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1174",
    "data-name": "Rectangle 1174",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 299.87)",
    fill: "#f5f5f5"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1175",
    "data-name": "Rectangle 1175",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 305.862)",
    fill: "#f5f5f5"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1176",
    "data-name": "Rectangle 1176",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 311.854)",
    fill: "#f5f5f5"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1177",
    "data-name": "Rectangle 1177",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 317.846)",
    fill: "#f5f5f5"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 323.836)",
    fill: "#f5f5f5"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1179",
    "data-name": "Rectangle 1179",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 329.828)",
    fill: "#f5f5f5"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1180",
    "data-name": "Rectangle 1180",
    width: 3.574,
    height: 3.574,
    transform: "translate(432.158 335.82)",
    fill: "#f5f5f5"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1181",
    "data-name": "Rectangle 1181",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 281.896)",
    fill: "#f5f5f5"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1182",
    "data-name": "Rectangle 1182",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 287.888)",
    fill: "#f5f5f5"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 293.88)",
    fill: "#f5f5f5"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1184",
    "data-name": "Rectangle 1184",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 299.87)",
    fill: "#f5f5f5"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1185",
    "data-name": "Rectangle 1185",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 305.862)",
    fill: "#f5f5f5"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1186",
    "data-name": "Rectangle 1186",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 311.854)",
    fill: "#f5f5f5"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1187",
    "data-name": "Rectangle 1187",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 317.846)",
    fill: "#f5f5f5"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 323.836)",
    fill: "#f5f5f5"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 3.574,
    height: 3.574,
    transform: "translate(437.834 329.828)",
    fill: "#f5f5f5"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1190",
    "data-name": "Rectangle 1190",
    width: 5.999,
    height: 286.161,
    transform: "translate(404.06 102.524)",
    fill: "#f5f5f5"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1191",
    "data-name": "Rectangle 1191",
    width: 5.999,
    height: 286.161,
    transform: "translate(291.219 102.524)",
    fill: "#f5f5f5"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1192",
    "data-name": "Rectangle 1192",
    width: 5.999,
    height: 286.161,
    transform: "translate(178.379 102.524)",
    fill: "#f5f5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M237.413,243.943H219.119v-1.218c0-2.391,2.678-4.292,5.864-4.162l7.166.289c2.952.119,5.264,1.947,5.264,4.162Z",
    transform: "translate(99.326 108.137)",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M208.431,220.139a2.372,2.372,0,0,0-2.369-2.258H189.843a2.372,2.372,0,0,0-2.369,2.258l3.85,33.8h24.208Z",
    transform: "translate(84.981 98.764)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M236.207,183.678h-6.043l-6.793,63.835h6.043a2.067,2.067,0,0,0,2.007-1.812l6.406-60.209a1.6,1.6,0,0,0-1.62-1.814",
    transform: "translate(101.253 83.26)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M254.53,247.513H163.959a1.6,1.6,0,0,1-1.62-1.814l6.406-60.207a2.065,2.065,0,0,1,2.006-1.814h90.572a1.6,1.6,0,0,1,1.619,1.814L256.535,245.7a2.065,2.065,0,0,1-2.006,1.814",
    transform: "translate(73.582 83.26)",
    fill: "#ebebeb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M251.691,240.917H166.282a1.4,1.4,0,0,1-1.414-1.583l5.589-52.529a1.8,1.8,0,0,1,1.751-1.581h85.409a1.4,1.4,0,0,1,1.413,1.581l-5.589,52.529a1.8,1.8,0,0,1-1.75,1.583",
    transform: "translate(74.73 83.961)",
    fill: "#fafafa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M217.113,240.886h-29.8a1.3,1.3,0,0,0-1.3,1.3v.023a1.3,1.3,0,0,0,1.3,1.3h29.8a1.3,1.3,0,0,0,1.3-1.3v-.023a1.3,1.3,0,0,0-1.3-1.3",
    transform: "translate(84.32 109.193)",
    fill: "#e6e6e6"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1193",
    "data-name": "Rectangle 1193",
    width: 73.734,
    height: 11.124,
    transform: "translate(301.017 351.943)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M118.1,362.933h-1.84a.427.427,0,0,1-.423-.417l-2.911-112.693h8.506l-2.91,112.693a.426.426,0,0,1-.423.417",
    transform: "translate(51.189 113.244)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M72.656,362.933H68.4l12-113.11h8.508Z",
    transform: "translate(31.006 113.244)",
    fill: "#f0f0f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M264.927,362.933h0l-16.3-113.11h8.506l12,113.11Z",
    transform: "translate(112.701 113.244)",
    fill: "#e6e6e6"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 215.554,
    height: 11.124,
    transform: "translate(106.493 351.943)",
    fill: "#f5f5f5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M219.06,362.933h-4.886l0,0-1.808-113.107h8.506Z",
    transform: "translate(96.262 113.244)",
    fill: "#f0f0f0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M170.428,241.807H168.17a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(76.035 108.136)",
    fill: "#f5f5f5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M172.576,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(77.009 108.136)",
    fill: "#f5f5f5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M174.723,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(77.982 108.136)",
    fill: "#f5f5f5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M176.871,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(78.955 108.136)",
    fill: "#f5f5f5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M179.019,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(79.929 108.136)",
    fill: "#f5f5f5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M181.167,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(80.903 108.136)",
    fill: "#f5f5f5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M183.315,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(81.876 108.136)",
    fill: "#f5f5f5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M185.464,241.807h-2.258a.433.433,0,0,1-.433-.432v-2.388a.433.433,0,0,1,.433-.432h1.622a.426.426,0,0,1,.414.32l.638,2.389a.431.431,0,0,1-.416.542",
    transform: "translate(82.85 108.136)",
    fill: "#f5f5f5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M187.61,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(83.823 108.136)",
    fill: "#f5f5f5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M189.758,241.807H187.5a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(84.797 108.136)",
    fill: "#f5f5f5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M191.906,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(85.771 108.136)",
    fill: "#f5f5f5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M194.054,241.807H191.8a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(86.744 108.136)",
    fill: "#f5f5f5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M196.2,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(87.718 108.136)",
    fill: "#f5f5f5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M198.349,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(88.691 108.136)",
    fill: "#f5f5f5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M200.5,241.807h-2.258a.432.432,0,0,1-.432-.432v-2.388a.432.432,0,0,1,.432-.432h1.622a.429.429,0,0,1,.416.32l.638,2.389a.432.432,0,0,1-.417.542",
    transform: "translate(89.665 108.136)",
    fill: "#f5f5f5"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 50.502,
    height: 3.761,
    transform: "translate(241.932 348.319)",
    fill: "#ebebeb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M166.315,256.822h-78.1a6.784,6.784,0,0,0-6.784,6.784v5.132H173.1v-5.132a6.784,6.784,0,0,0-6.784-6.784",
    transform: "translate(36.914 116.416)",
    fill: "#e0e0e0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M85.1,325.476l29.371-2.886V281.312H126.11v41.266l29.49,2.9a5.719,5.719,0,0,1,5.159,5.691v4.411H79.939v-4.411a5.719,5.719,0,0,1,5.159-5.691",
    transform: "translate(36.236 127.517)",
    fill: "#e0e0e0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M128.175,324.79a7.611,7.611,0,1,0,7.611-7.611,7.612,7.612,0,0,0-7.611,7.611",
    transform: "translate(58.101 143.776)",
    fill: "#e0e0e0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M92.062,324.79a7.611,7.611,0,1,1-7.611-7.611,7.612,7.612,0,0,1,7.611,7.611",
    transform: "translate(34.831 143.776)",
    fill: "#e0e0e0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M107.927,298.885h4.434a5.609,5.609,0,0,0,5.608-5.608V262.119H102.319v31.157a5.609,5.609,0,0,0,5.608,5.608",
    transform: "translate(46.381 118.817)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M140.948,295.437c-4.061-15.358-13.206-55.092-15.132-107.585a15.1,15.1,0,0,0-15.107-14.524h-27.1A15.113,15.113,0,0,0,68.491,188.37c-.106,24.686,1.619,75.148,15.543,116.166l51.573-1.9a5.738,5.738,0,0,0,5.341-7.2",
    transform: "translate(31.045 78.569)",
    fill: "#ebebeb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M134.88,300.885s-13.912-49.5-16.213-112.174a13.932,13.932,0,0,0-13.934-13.4h-25A13.94,13.94,0,0,0,65.79,189.187c-.1,22.77,1.494,73.862,14.337,111.7Z",
    transform: "translate(29.821 79.469)",
    fill: "#e6e6e6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M105.951,238.173s29.7-6.008,58.376-3.1-13.492,40.378-13.492,40.378h-5.918s22.343-23.757,21.1-29.672-57.519,1.882-57.519,1.882Z",
    transform: "translate(48.027 106.197)",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M80.131,300.885h48.635s-13.914-49.5-16.219-112.174a13.929,13.929,0,0,0-13.934-13.4H79.743a13.945,13.945,0,0,0-13.955,13.875c-.093,22.763,1.5,73.855,14.343,111.694",
    transform: "translate(29.82 79.47)",
    fill: "#e0e0e0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M176.566,260.922H77.705a2.73,2.73,0,0,0-2.729,2.729v.5a2.73,2.73,0,0,0,2.729,2.729h98.86a2.73,2.73,0,0,0,2.729-2.729v-.5a2.73,2.73,0,0,0-2.729-2.729",
    transform: "translate(33.986 118.275)",
    fill: "#e0e0e0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M399.156,314.457c.017-.536,1.822-53.832,10.491-62.261,8.432-8.2,18.109-.305,18.515.035l.869-1.042c-.109-.093-11.029-9.008-20.33.035-9.058,8.808-10.83,60.973-10.9,63.191Z",
    transform: "translate(180.321 112.043)",
    fill: "#e0e0e0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M403.907,328.915c.063-.638,5.925-63.98-17.208-90.529l-1.022.891c22.748,26.108,16.941,88.875,16.88,89.506Z",
    transform: "translate(174.826 108.059)",
    fill: "#e0e0e0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M399.005,323.736l1.353-.09c-.048-.718-4.529-72.012,12.44-87.619l-.918-1c-17.443,16.044-13.07,85.747-12.875,88.708",
    transform: "translate(180.583 106.537)",
    fill: "#e0e0e0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M407.534,313.878l1.357-.01c-.017-1.963-.561-48.156-13.681-55.676a9.282,9.282,0,0,0-8.49-.828c-7.934,3.283-11.866,17.4-12.029,18l1.308.358c.039-.141,3.921-14.08,11.241-17.105a7.992,7.992,0,0,1,7.3.751c12.45,7.134,12.994,54.036,13,54.509",
    transform: "translate(169.846 116.356)",
    fill: "#e0e0e0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M400.869,313.234l1.355-.077c-.02-.365-1.979-36.5,7.774-49.236,2.363-3.084,4.928-4.555,7.638-4.366,6.39.448,11.748,9.8,11.8,9.893l1.182-.667c-.232-.411-5.77-10.08-12.888-10.579-3.184-.225-6.153,1.424-8.813,4.895-10.058,13.132-8.137,48.633-8.05,50.137",
    transform: "translate(181.621 117.033)",
    fill: "#e0e0e0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M401.039,330.811c.266-3.505,6.376-86.022-4.375-100.562l-1.091.805c10.454,14.139,4.177,98.8,4.113,99.654Z",
    transform: "translate(179.311 104.371)",
    fill: "#e0e0e0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M387.753,264.54s6.45,2.378,4.531,7.99-22.311,14.853-22.311,14.853-8.541-7.829-.7-20.561,18.3-6.3,18.477-2.282",
    transform: "translate(165.889 117.543)",
    fill: "#ebebeb"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M402.514,256.361s-6.868-.288-7.258,5.632,14.877,22.294,14.877,22.294,10.9-3.938,8.557-18.71-14.47-12.856-16.177-9.215",
    transform: "translate(179.165 115.036)",
    fill: "#ebebeb"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M405.569,238.567s-4.579-.491-4.21-3.28,17.8-9.968,28.083,1.639c0,0-6.585,11.312-16.1,11.459s-7.769-9.818-7.769-9.818",
    transform: "translate(181.924 104.496)",
    fill: "#ebebeb"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M404.428,236.019s4.146,2,5.309-.557S399.9,217.588,385.034,222c0,0-.394,13.083,7.607,18.243s11.788-4.225,11.788-4.225",
    transform: "translate(174.533 100.272)",
    fill: "#ebebeb"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M413.965,262.676s-3.161-2.552.249-3.8,20.144-.891,20.318,15.685c0,0-19.49,3.238-21.9-3.075s1.334-8.813,1.334-8.813",
    transform: "translate(186.677 117.15)",
    fill: "#ebebeb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M392.365,237.094s3.159-2.552-.25-3.8-20.144-.891-20.319,15.685c0,0,19.489,3.238,21.9-3.075s-1.333-8.813-1.333-8.813",
    transform: "translate(168.533 105.554)",
    fill: "#ebebeb"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M395.665,245.637s.278-3.1-2.226-1.886-11.227,10.628-2.184,19.558c0,0,12.173-9.016,9.978-13.71s-5.568-3.962-5.568-3.962",
    transform: "translate(175.536 110.363)",
    fill: "#ebebeb"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M416.076,248.877s-1.889-2.475.878-2.782,15.165,3,12.277,15.379c0,0-15.105-1.135-15.752-6.277s2.6-6.32,2.6-6.32",
    transform: "translate(187.389 111.545)",
    fill: "#ebebeb"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M381.87,345.352H433.7l5.591-56.742H376.279Z",
    transform: "translate(170.566 130.825)",
    fill: "#f0f0f0"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 68.543,
    height: 12.522,
    transform: "translate(544.077 413.173)",
    fill: "#e6e6e6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M619.667,366.419c0,9.089-126.156,16.456-281.778,16.456S56.111,375.508,56.111,366.419s126.156-16.456,281.778-16.456,281.778,7.368,281.778,16.456",
    transform: "translate(25.435 158.637)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(232.834 43.115)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M188.435,37.232a15.123,15.123,0,1,1-20.659-5.537,15.125,15.125,0,0,1,20.659,5.537",
    transform: "translate(-160.211 -29.667)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(232.834 43.115)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M188.435,37.232a15.123,15.123,0,1,1-20.659-5.537,15.125,15.125,0,0,1,20.659,5.537",
    transform: "translate(-160.211 -29.667)",
    fill: "#f48221"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(243.52 54.517)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M167.785,40.027c.467.809,1.4.762,2.546.484l-1.729-3c-1.089.875-1.244,1.773-.817,2.514",
    transform: "translate(-167.564 -37.513)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(249.926 58.177)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M171.972,40.226l1.721,2.981c1.122-.9,1.314-1.769.9-2.492-.477-.825-1.442-.785-2.617-.488",
    transform: "translate(-171.972 -40.031)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(235.049 45.33)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M168.193,32.922a12.909,12.909,0,1,0,17.633,4.728,12.909,12.909,0,0,0-17.633-4.728M178.927,49.67l1.089,1.886-1.381.8-1.078-1.87a8.516,8.516,0,0,1-4.934.984l-.225-2.138a7.487,7.487,0,0,0,4.108-.664L174.561,45.3c-2.132.623-4.486,1.174-5.838-1.167-.991-1.718-.61-3.936,1.872-5.706l-1.1-1.9,1.381-.8,1.08,1.869a8.354,8.354,0,0,1,4.013-.946l.291,2.1a8.044,8.044,0,0,0-3.254.666l1.963,3.4c2.132-.625,4.511-1.211,5.863,1.131.991,1.718.584,3.928-1.905,5.725",
    transform: "translate(-161.734 -31.191)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(270.878 62.393)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M205.974,55.576A9.973,9.973,0,1,1,199.032,43.3a9.973,9.973,0,0,1,6.942,12.277",
    transform: "translate(-186.389 -42.932)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(270.878 62.393)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M205.974,55.576A9.973,9.973,0,1,1,199.032,43.3a9.973,9.973,0,0,1,6.942,12.277",
    transform: "translate(-186.389 -42.932)",
    fill: "#f48221"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(279.259 69.122)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M192.19,48.36c-.164.593.291,1.013.95,1.421l.61-2.2c-.916-.108-1.41.234-1.561.778",
    transform: "translate(-192.156 -47.562)",
    fill: "#fff"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(280.586 73.381)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M193.676,50.493l-.607,2.187c.94.115,1.44-.2,1.587-.731.169-.6-.3-1.041-.98-1.456",
    transform: "translate(-193.069 -50.493)",
    fill: "#fff"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(272.339 63.855)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M198.186,44.25a8.513,8.513,0,1,0,5.925,10.48,8.513,8.513,0,0,0-5.925-10.48m-2.918,12.789-.384,1.385-1.014-.282.381-1.372a5.615,5.615,0,0,1-2.742-1.866l.9-1.094a4.929,4.929,0,0,0,2.21,1.626l.686-2.472c-1.279-.715-2.626-1.568-2.149-3.286.35-1.26,1.57-2.106,3.55-1.756l.387-1.4,1.013.28-.381,1.372a5.51,5.51,0,0,1,2.3,1.45l-.853,1.107a5.3,5.3,0,0,0-1.818-1.222l-.692,2.5c1.279.715,2.654,1.562,2.177,3.28-.35,1.26-1.578,2.091-3.574,1.75",
    transform: "translate(-187.394 -43.938)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(514.535 480.016)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M382.27,337.861a15.123,15.123,0,1,1-20.659-5.539,15.124,15.124,0,0,1,20.659,5.539",
    transform: "translate(-354.047 -330.295)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(514.535 480.016)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M382.27,337.861a15.123,15.123,0,1,1-20.659-5.539,15.124,15.124,0,0,1,20.659,5.539",
    transform: "translate(-354.047 -330.295)",
    fill: "#f48221"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(525.379 491.721)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M361.73,340.863c.466.809,1.4.762,2.546.484l-1.729-3c-1.089.875-1.244,1.773-.817,2.514",
    transform: "translate(-361.509 -338.349)",
    fill: "#fff"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(531.307 495.242)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M365.588,340.967l1.721,2.981c1.122-.9,1.314-1.769.9-2.492-.475-.825-1.44-.785-2.616-.488",
    transform: "translate(-365.588 -340.772)",
    fill: "#fff"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(516.75 482.231)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M362.028,333.55a12.909,12.909,0,1,0,17.633,4.728,12.908,12.908,0,0,0-17.633-4.728M372.762,350.3l1.089,1.886-1.381.8-1.078-1.87a8.515,8.515,0,0,1-4.934.984l-.225-2.138a7.486,7.486,0,0,0,4.108-.664l-1.945-3.369c-2.132.623-4.486,1.174-5.838-1.167-.993-1.718-.61-3.936,1.872-5.706l-1.1-1.9,1.381-.8,1.08,1.869a8.354,8.354,0,0,1,4.013-.946l.291,2.1a8.043,8.043,0,0,0-3.254.666l1.963,3.4c2.132-.625,4.511-1.211,5.863,1.131.991,1.718.584,3.928-1.905,5.725",
    transform: "translate(-355.571 -331.819)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(552.578 499.295)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M399.81,356.2a9.973,9.973,0,1,1-6.942-12.277A9.973,9.973,0,0,1,399.81,356.2",
    transform: "translate(-380.224 -343.561)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(552.578 499.295)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M399.81,356.2a9.973,9.973,0,1,1-6.942-12.277A9.973,9.973,0,0,1,399.81,356.2",
    transform: "translate(-380.224 -343.561)",
    fill: "#f48221"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(561.171 505.889)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M386.171,348.9c-.164.593.291,1.013.95,1.421l.61-2.2c-.916-.108-1.41.234-1.561.777",
    transform: "translate(-386.137 -348.098)",
    fill: "#fff"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(562.412 510.283)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M387.6,351.122l-.607,2.187c.94.115,1.44-.2,1.587-.731.169-.6-.3-1.041-.98-1.456",
    transform: "translate(-386.991 -351.121)",
    fill: "#fff"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(554.038 500.756)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M392.021,344.878a8.513,8.513,0,1,0,5.925,10.48,8.513,8.513,0,0,0-5.925-10.48M389.1,357.667l-.384,1.384-1.014-.28.381-1.372a5.615,5.615,0,0,1-2.742-1.866l.9-1.094a4.928,4.928,0,0,0,2.21,1.626l.686-2.472c-1.279-.715-2.626-1.568-2.149-3.286.35-1.26,1.57-2.106,3.549-1.756l.388-1.4,1.013.28-.381,1.372a5.51,5.51,0,0,1,2.3,1.45l-.853,1.107a5.3,5.3,0,0,0-1.818-1.222l-.692,2.5c1.279.715,2.654,1.562,2.177,3.28-.35,1.26-1.578,2.091-3.574,1.75",
    transform: "translate(-381.229 -344.566)",
    fill: "#fff"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(259.649 97.41)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M178.725,68.11c.169.384.589.41,1.113.342l-.623-1.424c-.53.337-.644.731-.49,1.083",
    transform: "translate(-178.662 -67.027)",
    fill: "#fff"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(261.978 99.651)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M180.265,68.6l.621,1.416c.545-.343.674-.724.523-1.068-.171-.392-.6-.421-1.144-.347",
    transform: "translate(-180.265 -68.569)",
    fill: "#fff"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(510.208 418.495)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M351.159,289.011c-.33.873.3,1.568,1.24,2.277l1.224-3.238c-1.368-.288-2.161.16-2.463.961",
    transform: "translate(-351.07 -287.963)",
    fill: "#fff"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(510.835 424.968)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M352.717,292.417l-1.216,3.221c1.4.3,2.2-.1,2.5-.886.337-.892-.305-1.613-1.28-2.334",
    transform: "translate(-351.501 -292.416)",
    fill: "#fff"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(227.681 455.04)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M156.668,313.97c.031.419.42.58.939.689l-.122-1.549c-.61.144-.849.477-.817.86",
    transform: "translate(-156.665 -313.109)",
    fill: "#fff"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(229.432 457.771)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M157.87,314.988l.121,1.542c.628-.147.875-.464.846-.839-.033-.426-.433-.6-.966-.7",
    transform: "translate(-157.87 -314.988)",
    fill: "#fff"
  }))))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M389.06,116.465v5.2l2.68.253a13.887,13.887,0,0,0,2,4.806l-1.721,2.08,3.678,3.678,2.08-1.721a13.888,13.888,0,0,0,4.806,2l.253,2.68h5.2l.253-2.68a13.888,13.888,0,0,0,4.806-2l2.078,1.721,3.68-3.678-1.721-2.08a13.916,13.916,0,0,0,2-4.806l2.68-.253v-5.2l-2.68-.253a13.916,13.916,0,0,0-2-4.806l1.721-2.078-3.68-3.68-2.078,1.721a13.915,13.915,0,0,0-4.806-2l-.253-2.68h-5.2l-.253,2.68a13.915,13.915,0,0,0-4.806,2l-2.08-1.721-3.678,3.68,1.721,2.078a13.886,13.886,0,0,0-2,4.806Zm16.376-4.443a7.044,7.044,0,1,1-7.044,7.044,7.044,7.044,0,0,1,7.044-7.044",
    transform: "translate(176.359 46.549)",
    fill: "#407bff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M397.627,149.467a11.875,11.875,0,0,0,4.111-1.711l1.779,1.472,3.148-3.146-1.474-1.779a11.877,11.877,0,0,0,1.711-4.111l2.292-.215v-4.451l-2.292-.217a11.888,11.888,0,0,0-1.711-4.111l1.474-1.777-3.148-3.148-1.779,1.472a11.9,11.9,0,0,0-4.111-1.709l-.215-2.292h-4.451l-.217,2.292a11.9,11.9,0,0,0-4.111,1.709l-1.777-1.472-3.148,3.148,1.472,1.777a11.912,11.912,0,0,0-1.709,4.111l-2.292.217v4.451l2.292.215a11.9,11.9,0,0,0,1.709,4.111l-1.472,1.779,3.148,3.146,1.777-1.472a11.875,11.875,0,0,0,4.111,1.711l.217,2.292h4.451Zm-8.467-11.716a6.025,6.025,0,1,1,6.025,6.025,6.025,6.025,0,0,1-6.025-6.025",
    transform: "translate(172.787 56.093)",
    fill: "#407bff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M389.049,129.156l1.493,1.237,2.645-2.644-1.237-1.494a10,10,0,0,0,1.436-3.453l1.924-.182v-3.738l-1.924-.182a10,10,0,0,0-1.436-3.453l1.237-1.494-2.645-2.644-1.493,1.237a10,10,0,0,0-3.454-1.436l-.18-1.926h-3.739l-.18,1.924a10,10,0,0,0-3.454,1.436l-1.493-1.237-2.645,2.644,1.237,1.494A10,10,0,0,0,373.7,118.7l-1.924.182v3.738l1.924.182a10,10,0,0,0,1.436,3.453L373.9,127.75l2.645,2.644,1.493-1.237a10,10,0,0,0,3.454,1.436l.18,1.926h3.739l.18-1.926a10,10,0,0,0,3.454-1.436m-10.565-8.4a5.061,5.061,0,1,1,5.062,5.062,5.061,5.061,0,0,1-5.062-5.062",
    transform: "translate(168.526 49.403)",
    fill: "#407bff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M389.06,116.465v5.2l2.68.253a13.887,13.887,0,0,0,2,4.806l-1.721,2.08,3.678,3.678,2.08-1.721a13.888,13.888,0,0,0,4.806,2l.253,2.68h5.2l.253-2.68a13.888,13.888,0,0,0,4.806-2l2.078,1.721,3.68-3.678-1.721-2.08a13.916,13.916,0,0,0,2-4.806l2.68-.253v-5.2l-2.68-.253a13.916,13.916,0,0,0-2-4.806l1.721-2.078-3.68-3.68-2.078,1.721a13.915,13.915,0,0,0-4.806-2l-.253-2.68h-5.2l-.253,2.68a13.915,13.915,0,0,0-4.806,2l-2.08-1.721-3.678,3.68,1.721,2.078a13.886,13.886,0,0,0-2,4.806Zm16.376-4.443a7.044,7.044,0,1,1-7.044,7.044,7.044,7.044,0,0,1,7.044-7.044",
    transform: "translate(176.359 46.549)",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M397.627,149.467a11.875,11.875,0,0,0,4.111-1.711l1.779,1.472,3.148-3.146-1.474-1.779a11.877,11.877,0,0,0,1.711-4.111l2.292-.215v-4.451l-2.292-.217a11.888,11.888,0,0,0-1.711-4.111l1.474-1.777-3.148-3.148-1.779,1.472a11.9,11.9,0,0,0-4.111-1.709l-.215-2.292h-4.451l-.217,2.292a11.9,11.9,0,0,0-4.111,1.709l-1.777-1.472-3.148,3.148,1.472,1.777a11.912,11.912,0,0,0-1.709,4.111l-2.292.217v4.451l2.292.215a11.9,11.9,0,0,0,1.709,4.111l-1.472,1.779,3.148,3.146,1.777-1.472a11.875,11.875,0,0,0,4.111,1.711l.217,2.292h4.451Zm-8.467-11.716a6.025,6.025,0,1,1,6.025,6.025,6.025,6.025,0,0,1-6.025-6.025",
    transform: "translate(172.787 56.093)",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M389.049,129.156l1.493,1.237,2.645-2.644-1.237-1.494a10,10,0,0,0,1.436-3.453l1.924-.182v-3.738l-1.924-.182a10,10,0,0,0-1.436-3.453l1.237-1.494-2.645-2.644-1.493,1.237a10,10,0,0,0-3.454-1.436l-.18-1.926h-3.739l-.18,1.924a10,10,0,0,0-3.454,1.436l-1.493-1.237-2.645,2.644,1.237,1.494A10,10,0,0,0,373.7,118.7l-1.924.182v3.738l1.924.182a10,10,0,0,0,1.436,3.453L373.9,127.75l2.645,2.644,1.493-1.237a10,10,0,0,0,3.454,1.436l.18,1.926h3.739l.18-1.926a10,10,0,0,0,3.454-1.436m-10.565-8.4a5.061,5.061,0,1,1,5.062,5.062,5.061,5.061,0,0,1-5.062-5.062",
    transform: "translate(168.526 49.403)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M105.731,200.667l-3.858,3.491,1.609,2.157a13.9,13.9,0,0,0-2.224,4.7l-2.7.119-.26,5.2,2.671.388a13.863,13.863,0,0,0,1.741,4.9l-1.818,1.985,3.489,3.858,2.157-1.609a13.888,13.888,0,0,0,4.706,2.224l.118,2.7,5.2.26.387-2.67a13.894,13.894,0,0,0,4.9-1.742l1.985,1.818,3.858-3.489-1.61-2.157a13.864,13.864,0,0,0,2.225-4.706l2.7-.118.262-5.2-2.67-.387a13.933,13.933,0,0,0-1.743-4.9l1.818-1.985-3.489-3.859-2.158,1.609a13.9,13.9,0,0,0-4.7-2.224l-.119-2.7-5.2-.26-.387,2.67a13.9,13.9,0,0,0-4.9,1.742Zm14.279,9.166a7.044,7.044,0,1,1-9.949-.5,7.043,7.043,0,0,1,9.949.5",
    transform: "translate(44.559 89.786)",
    fill: "#407bff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M94.761,209.755l.084,1.937,3.734.187.279-1.918a9.992,9.992,0,0,0,3.524-1.253l1.426,1.307,2.773-2.507-1.157-1.549a9.979,9.979,0,0,0,1.6-3.382l1.937-.084.187-3.734-1.92-.279a9.99,9.99,0,0,0-1.251-3.524l1.307-1.426-2.508-2.773-1.548,1.157a9.992,9.992,0,0,0-3.382-1.6l-.084-1.937-3.735-.187-.278,1.92a9.942,9.942,0,0,0-3.524,1.251L90.8,190.056l-2.773,2.507,1.157,1.549a9.992,9.992,0,0,0-1.6,3.382l-1.937.084-.187,3.735,1.918.278a9.97,9.97,0,0,0,1.251,3.524l-1.307,1.426,2.508,2.773,1.549-1.157a9.979,9.979,0,0,0,3.382,1.6m-.853-13.474a5.061,5.061,0,1,1-.359,7.149,5.062,5.062,0,0,1,.359-7.149",
    transform: "translate(38.738 85.306)",
    fill: "#407bff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M105.731,200.667l-3.858,3.491,1.609,2.157a13.9,13.9,0,0,0-2.224,4.7l-2.7.119-.26,5.2,2.671.388a13.863,13.863,0,0,0,1.741,4.9l-1.818,1.985,3.489,3.858,2.157-1.609a13.888,13.888,0,0,0,4.706,2.224l.118,2.7,5.2.26.387-2.67a13.894,13.894,0,0,0,4.9-1.742l1.985,1.818,3.858-3.489-1.61-2.157a13.864,13.864,0,0,0,2.225-4.706l2.7-.118.262-5.2-2.67-.387a13.933,13.933,0,0,0-1.743-4.9l1.818-1.985-3.489-3.859-2.158,1.609a13.9,13.9,0,0,0-4.7-2.224l-.119-2.7-5.2-.26-.387,2.67a13.9,13.9,0,0,0-4.9,1.742Zm14.279,9.166a7.044,7.044,0,1,1-9.949-.5,7.043,7.043,0,0,1,9.949.5",
    transform: "translate(44.559 89.786)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M94.761,209.755l.084,1.937,3.734.187.279-1.918a9.992,9.992,0,0,0,3.524-1.253l1.426,1.307,2.773-2.507-1.157-1.549a9.979,9.979,0,0,0,1.6-3.382l1.937-.084.187-3.734-1.92-.279a9.99,9.99,0,0,0-1.251-3.524l1.307-1.426-2.508-2.773-1.548,1.157a9.992,9.992,0,0,0-3.382-1.6l-.084-1.937-3.735-.187-.278,1.92a9.942,9.942,0,0,0-3.524,1.251L90.8,190.056l-2.773,2.507,1.157,1.549a9.992,9.992,0,0,0-1.6,3.382l-1.937.084-.187,3.735,1.918.278a9.97,9.97,0,0,0,1.251,3.524l-1.307,1.426,2.508,2.773,1.549-1.157a9.979,9.979,0,0,0,3.382,1.6m-.853-13.474a5.061,5.061,0,1,1-.359,7.149,5.062,5.062,0,0,1,.359-7.149",
    transform: "translate(38.738 85.306)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(349.488 67.894)",
    opacity: 0.42,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M249.783,68.281l.084,1.937,3.734.187.279-1.918a9.992,9.992,0,0,0,3.524-1.253l1.426,1.307,2.773-2.507-1.157-1.549a9.992,9.992,0,0,0,1.6-3.382l1.936-.084.189-3.734-1.92-.279A9.99,9.99,0,0,0,261,53.482l1.306-1.426L259.8,49.284l-1.548,1.157a9.992,9.992,0,0,0-3.382-1.6l-.084-1.937-3.735-.187-.278,1.92a9.942,9.942,0,0,0-3.524,1.251l-1.426-1.307-2.773,2.507,1.155,1.549a9.975,9.975,0,0,0-1.6,3.382l-1.937.084-.187,3.734,1.918.279a9.98,9.98,0,0,0,1.251,3.524l-1.307,1.426,2.508,2.773,1.549-1.157a9.978,9.978,0,0,0,3.382,1.6m-.853-13.473a5.061,5.061,0,1,1-.359,7.149,5.062,5.062,0,0,1,.359-7.149",
    transform: "translate(-240.48 -46.717)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(349.488 67.894)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M249.783,68.281l.084,1.937,3.734.187.279-1.918a9.992,9.992,0,0,0,3.524-1.253l1.426,1.307,2.773-2.507-1.157-1.549a9.992,9.992,0,0,0,1.6-3.382l1.936-.084.189-3.734-1.92-.279A9.99,9.99,0,0,0,261,53.482l1.306-1.426L259.8,49.284l-1.548,1.157a9.992,9.992,0,0,0-3.382-1.6l-.084-1.937-3.735-.187-.278,1.92a9.942,9.942,0,0,0-3.524,1.251l-1.426-1.307-2.773,2.507,1.155,1.549a9.975,9.975,0,0,0-1.6,3.382l-1.937.084-.187,3.734,1.918.279a9.98,9.98,0,0,0,1.251,3.524l-1.307,1.426,2.508,2.773,1.549-1.157a9.978,9.978,0,0,0,3.382,1.6m-.853-13.473a5.061,5.061,0,1,1-.359,7.149,5.062,5.062,0,0,1,.359-7.149",
    transform: "translate(-240.48 -46.717)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(268.342 87.256)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M197.658,64.109a6.792,6.792,0,1,1-8.946-3.5,6.792,6.792,0,0,1,8.946,3.5",
    transform: "translate(-184.644 -60.04)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(268.342 87.256)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M197.658,64.109a6.792,6.792,0,1,1-8.946-3.5,6.792,6.792,0,0,1,8.946,3.5",
    transform: "translate(-184.644 -60.04)",
    fill: "#f48221"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(269.336 88.251)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M188.8,61.213a5.8,5.8,0,1,0,7.637,2.984,5.8,5.8,0,0,0-7.637-2.984m3.962,8.008.392.9-.655.286-.389-.888a3.809,3.809,0,0,1-2.251.195l.006-.965a3.356,3.356,0,0,0,1.867-.093l-.7-1.6c-.982.173-2.061.3-2.548-.809a1.9,1.9,0,0,1,1.118-2.455l-.4-.9.655-.288.389.888a3.757,3.757,0,0,1,1.837-.224l.026.952a3.607,3.607,0,0,0-1.485.137l.708,1.616c.984-.173,2.074-.318,2.561.795.357.815.067,1.782-1.134,2.46",
    transform: "translate(-185.328 -60.725)",
    fill: "#fff"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(273.507 92.348)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M188.3,64.721c.218.379.657.356,1.193.227l-.811-1.4c-.51.41-.583.83-.382,1.177",
    transform: "translate(-188.198 -63.544)",
    fill: "#fff"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(275.631 94.232)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M189.659,64.868l.753,1.863c.722-.426.9-.916.721-1.369-.208-.516-.77-.571-1.474-.494",
    transform: "translate(-189.659 -64.84)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(227.852 453.036)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M169.8,315.8a6.792,6.792,0,1,1-8.946-3.5,6.792,6.792,0,0,1,8.946,3.5",
    transform: "translate(-156.783 -311.73)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(227.852 453.036)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M169.8,315.8a6.792,6.792,0,1,1-8.946-3.5,6.792,6.792,0,0,1,8.946,3.5",
    transform: "translate(-156.783 -311.73)",
    fill: "#f48221"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(228.846 454.031)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M160.939,312.9a5.8,5.8,0,1,0,7.637,2.984,5.8,5.8,0,0,0-7.637-2.984m3.962,8.008.392.9-.655.286-.389-.888A3.808,3.808,0,0,1,162,321.4l.006-.965a3.369,3.369,0,0,0,1.867-.093l-.7-1.6c-.982.173-2.061.3-2.548-.81a1.9,1.9,0,0,1,1.118-2.455l-.4-.9.655-.288.389.888a3.76,3.76,0,0,1,1.838-.224l.025.952a3.607,3.607,0,0,0-1.485.137l.708,1.616c.984-.174,2.074-.318,2.561.795.358.815.067,1.782-1.134,2.46",
    transform: "translate(-157.467 -312.415)",
    fill: "#fff"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(233.017 458.128)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M160.44,316.411c.218.379.657.356,1.193.227l-.811-1.4c-.51.41-.583.83-.382,1.177",
    transform: "translate(-160.337 -315.234)",
    fill: "#fff"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(235.14 460.011)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M161.8,316.558l.753,1.863c.722-.426.9-.916.721-1.369-.208-.516-.77-.571-1.474-.494",
    transform: "translate(-161.798 -316.53)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(542.094 329.77)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M408.726,235.4l-.077.2-10.278,26.029-3.861,9.792L387.264,258.3l-14.254,4.633,14.225-36.021,9.029,3.566,11.918,4.71Z",
    transform: "translate(-373.01 -226.912)",
    fill: "#f48221"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M393.607,266.225,387.409,255l-12.195,3.962,12.309-31.176,18.391,7.261Zm-5.972-11.8,5.9,10.682L405.3,235.316l-17.5-6.91L376.029,258.2Z",
    transform: "translate(170.083 103.255)",
    fill: "#fff"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(560.742 333.335)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M402.832,234.485l-10.278,26.03a87.156,87.156,0,0,1-6.713-28.614l4.605-2.536,11.918,4.71Z",
    transform: "translate(-385.842 -229.365)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(561.177 329.766)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M400.362,271.418l7.245-13.117,14.251,4.632-14.222-36.023L386.141,235.4Z",
    transform: "translate(-386.141 -226.909)",
    fill: "#f48221"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M387.388,235.049l18.393-7.261,12.308,31.176L405.9,255l-6.2,11.222Zm29.887,23.15-11.763-29.791-17.5,6.91,11.762,29.791,5.9-10.682Z",
    transform: "translate(175.601 103.255)",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M400.7,198.285l2.543-1.988,2.148,2.41,2.857-1.5,1.683,2.755,3.08-.968L414.179,202l3.2-.4.607,3.17,3.223.176.03,3.228,3.141.75-.545,3.181,2.955,1.3-1.1,3.033,2.676,1.8-1.628,2.787,2.311,2.253-2.1,2.452,1.872,2.63-2.5,2.037,1.372,2.923-2.827,1.556.827,3.12-3.059,1.028.257,3.218-3.194.465-.321,3.212-3.225-.113-.891,3.1-3.154-.686-1.429,2.893-2.981-1.24-1.923,2.593-2.712-1.751-2.354,2.208-2.356-2.208-2.71,1.751-1.923-2.593-2.981,1.24-1.43-2.893-3.154.686-.889-3.1-3.225.113-.321-3.212-3.194-.465.257-3.218L375.719,238l.827-3.12-2.827-1.556,1.372-2.923-2.5-2.037,1.872-2.63-2.1-2.452,2.311-2.253-1.628-2.787,2.676-1.8-1.1-3.033,2.956-1.3-.545-3.181,3.139-.75.032-3.228,3.223-.176.607-3.17,3.2.4,1.164-3.011,3.08.968,1.683-2.755,2.857,1.5,2.148-2.41Z",
    transform: "translate(168.789 88.981)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(541.148 285.278)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M400.7,198.285l2.543-1.988,2.148,2.41,2.857-1.5,1.683,2.755,3.08-.968L414.179,202l3.2-.4.607,3.17,3.223.176.03,3.228,3.141.75-.545,3.181,2.955,1.3-1.1,3.033,2.676,1.8-1.628,2.787,2.311,2.253-2.1,2.452,1.872,2.63-2.5,2.037,1.372,2.923-2.827,1.556.827,3.12-3.059,1.028.257,3.218-3.194.465-.321,3.212-3.225-.113-.891,3.1-3.154-.686-1.429,2.893-2.981-1.24-1.923,2.593-2.712-1.751-2.354,2.208-2.356-2.208-2.71,1.751-1.923-2.593-2.981,1.24-1.43-2.893-3.154.686-.889-3.1-3.225.113-.321-3.212-3.194-.465.257-3.218L375.719,238l.827-3.12-2.827-1.556,1.372-2.923-2.5-2.037,1.872-2.63-2.1-2.452,2.311-2.253-1.628-2.787,2.676-1.8-1.1-3.033,2.956-1.3-.545-3.181,3.139-.75.032-3.228,3.223-.176.607-3.17,3.2.4,1.164-3.011,3.08.968,1.683-2.755,2.857,1.5,2.148-2.41Z",
    transform: "translate(-372.359 -196.297)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(545.086 289.187)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M423.884,223.4a24.408,24.408,0,1,1-24.408-24.408A24.408,24.408,0,0,1,423.884,223.4",
    transform: "translate(-375.069 -198.987)",
    fill: "#ff8f3b"
  }))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M381.787,219.389s1.959-4.129,4.5-4.377c4.887-.48,9.885,9.869,9.885,9.869s5.255-11.786,16.082-17.056c0,0-6.286,6.037-11.69,21.942-.416,1.227-6.133,2.972-7.474,2.2s-5.941-11.368-11.307-12.583",
    transform: "translate(173.062 94.206)",
    fill: "#fafafa"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M114.833,110.737c-3.318-5.934-9.765-8.644-14.4-6.053s-5.7,9.5-2.383,15.437,9.765,8.644,14.4,6.053,5.7-9.5,2.383-15.437",
    transform: "translate(43.571 47.008)",
    fill: "#407bff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M144.543,100.777,133.133,79.79s-7.97,17.1-19.432,23.507l5.815,10.4.916,1.638,5.823,10.414c11.461-6.409,30.2-4.252,30.2-4.252Z",
    transform: "translate(51.54 36.168)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(139.691 150.708)",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M114.833,110.737c-3.318-5.934-9.765-8.644-14.4-6.053s-5.7,9.5-2.383,15.437,9.765,8.644,14.4,6.053,5.7-9.5,2.383-15.437",
    transform: "translate(-96.12 -103.701)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(165.241 115.958)",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M144.543,100.777,133.133,79.79s-7.97,17.1-19.432,23.507l5.815,10.4.916,1.638,5.823,10.414c11.461-6.409,30.2-4.252,30.2-4.252Z",
    transform: "translate(-113.701 -79.79)",
    fill: "#fff"
  }))))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M108.461,119.055s8.25,11.952,15.959,16.315a1.282,1.282,0,0,0,1.618-.339l6.569-8.153a1.288,1.288,0,0,0-.478-1.992c-3.251-1.427-10.817-5.123-15.184-10.282-5.674-6.7-8.483,4.451-8.483,4.451",
    transform: "translate(49.165 50.978)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(157.626 163.439)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M108.461,119.055s8.25,11.952,15.959,16.315a1.282,1.282,0,0,0,1.618-.339l6.569-8.153a1.288,1.288,0,0,0-.478-1.992c-3.251-1.427-10.817-5.123-15.184-10.282-5.674-6.7-8.483,4.451-8.483,4.451",
    transform: "translate(-108.461 -112.461)",
    fill: "#f48221"
  }))))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M150.743,122.219c-2.626,1.468-10.079-6.86-16.645-18.6s-9.759-22.453-7.131-23.921,10.079,6.86,16.645,18.6,9.759,22.452,7.131,23.921",
    transform: "translate(57.137 36.049)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(185.298 117.4)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M149.012,118.185c-1.965,1.1-7.777-5.453-13.26-14.873-.318-.532-.629-1.089-.94-1.645-.375-.671-.741-1.325-1.083-1.974-5.033-9.5-7.511-17.7-5.563-18.79,2.1-1.171,8.468,6.226,14.226,16.524s8.715,19.586,6.62,20.757",
    transform: "translate(-127.502 -80.782)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(141.642 137.249)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M110.775,132.553s-2.822-2-7.934-11.145c-5.531-9.893-5.379-12.664-5.379-12.664l25.582-14.3s.307,3.591,5.493,12.869c5.15,9.211,7.819,10.94,7.819,10.94Z",
    transform: "translate(-97.463 -94.44)",
    fill: "#ff8f3b"
  }))))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M133.81,97.691c-.318-.532-.629-1.089-.94-1.645-.376-.67-.741-1.325-1.083-1.974l2.648-.836a1.23,1.23,0,0,1,1.452.671l.209.376a1.231,1.231,0,0,1-.186,1.588Z",
    transform: "translate(59.738 42.239)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(191.525 135.422)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M133.81,97.691c-.318-.532-.629-1.089-.94-1.645-.376-.67-.741-1.325-1.083-1.974l2.648-.836a1.23,1.23,0,0,1,1.452.671l.209.376a1.231,1.231,0,0,1-.186,1.588Z",
    transform: "translate(-131.787 -93.183)"
  }))))), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 29.989,
    height: 13.032,
    transform: "translate(162.146 408.997)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(162.144 408.996)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 29.989,
    height: 13.032,
    transform: "translate(0.001 0.001)",
    fill: "#c15200"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M111.471,295.145s-7.377-10.327-7.377-15.738,4.427-8.361,7.377-6.393c0,0-1.475-10.414,0-14.059s8.852-1.466,8.852-1.466a6.174,6.174,0,0,1,5.656-3.409,6.761,6.761,0,0,1,5.9,3.409,6.44,6.44,0,0,1,6.147-1.416c3.934.958,3.437,3.085,3.437,3.085s5.661-.01,6.89,1.758,3.688,25.117-1.475,32.5-27.541,9.843-35.41,1.728",
    transform: "translate(47.185 115.173)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(151.275 369.259)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M149.926,280.489c-.262,5.222-1.119,10.182-3.039,12.923-5.166,7.384-27.543,9.846-35.412,1.734,0,0-7.384-10.33-7.384-15.738s4.438-8.354,7.384-6.4c0,0-1.472-10.424,0-14.061s8.858-1.472,8.858-1.472a6.167,6.167,0,0,1,5.65-3.395,6.746,6.746,0,0,1,5.893,3.395,6.434,6.434,0,0,1,6.153-1.4c3.934.952,3.441,3.069,3.441,3.069s5.658-.012,6.889,1.76c.764,1.119,2.033,10.741,1.567,19.58",
    transform: "translate(-104.091 -254.084)",
    fill: "#ff8f3b"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(158.661 376.002)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M147.623,278.386c-.653-.262-4.14-1.586-5.129.355-1.119,2.126-10.33,11.318-13.835,7.813s-13.613-6.825-13.613-6.825a8.518,8.518,0,0,0,4.2-1.1c4.251-2.4,3.513-6.091,1.231-5.912-.567.045-11.3-1.808-11.3-1.808s7.87-.224,8.784-1.324c.932-1.1.186-10.872.932-10.685.728.167.355,9.957.542,11.616s7.054,1.745,7.968.814c.933-.914.673-13.405,2-12.565,1.324.857-.77,12.86.554,13.588,1.324.746,4.191,1.446,5.441.7,1.248-.728,2.389-13.5,3.116-12.939.746.541-.262,12.025.11,12.939.374.932,2.565.964,4.242.59,1.66-.374,3.2-14.838,3.2-14.838.764,1.119,2.033,10.741,1.567,19.58",
    transform: "translate(-109.173 -258.724)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(159.886 418.217)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M112.275,287.772s14.789,4.611,29.989,0l2.055,1.025v15.943a128.825,128.825,0,0,1-34.3,0l1.027-15.861Z",
    transform: "translate(-110.016 -287.771)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(421.819 98.975)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M301.478,73.659H290.25V69.966a1.862,1.862,0,0,1,1.862-1.862h7.5a1.862,1.862,0,0,1,1.862,1.862Z",
    transform: "translate(-290.25 -68.104)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(438.405 81.943)",
    opacity: 0.42,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M312.892,78.971H301.664V58.246a1.861,1.861,0,0,1,1.862-1.862h7.5a1.861,1.861,0,0,1,1.862,1.862Z",
    transform: "translate(-301.663 -56.384)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(454.993 85.646)",
    opacity: 0.71,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M324.305,77.816H313.077V60.794a1.861,1.861,0,0,1,1.862-1.862h7.5a1.861,1.861,0,0,1,1.862,1.862Z",
    transform: "translate(-313.077 -58.932)",
    fill: "#f48221"
  }))))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M335.719,83.706H324.491V47.8a1.86,1.86,0,0,1,1.86-1.86h7.506a1.861,1.861,0,0,1,1.862,1.86Z",
    transform: "translate(147.09 20.823)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(408.174 36.511)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M346.5,25.684l-2.9,1.01-4.268,1.479,2.078,1.554-20.292,28-17.951-8.05L280.861,75.455l4.354,3.562,19.468-22.5,18.307,8.2L345.923,33.06l1.815,1.366.394-9.3Z",
    transform: "translate(-280.861 -25.123)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(421.819 98.975)",
    opacity: 0.19,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M301.478,73.659H290.25V69.966a1.862,1.862,0,0,1,1.862-1.862h7.5a1.862,1.862,0,0,1,1.862,1.862Z",
    transform: "translate(-290.25 -68.104)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(438.405 81.864)",
    opacity: 0.42,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M312.892,78.917H301.664V58.192a1.861,1.861,0,0,1,1.862-1.862h7.5a1.861,1.861,0,0,1,1.862,1.862Z",
    transform: "translate(-301.663 -56.33)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(454.993 85.646)",
    opacity: 0.71,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M324.305,77.816H313.077V60.794a1.861,1.861,0,0,1,1.862-1.862h7.5a1.861,1.861,0,0,1,1.862,1.862Z",
    transform: "translate(-313.077 -58.932)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(471.58 66.762)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M335.719,83.706H324.491V47.8a1.86,1.86,0,0,1,1.86-1.86h7.506a1.861,1.861,0,0,1,1.862,1.86Z",
    transform: "translate(-324.49 -45.938)",
    fill: "#f48221"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(408.174 36.511)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M346.5,25.684l-2.9,1.01-4.268,1.479,2.078,1.554-20.292,28-17.951-8.05L280.861,75.455l4.354,3.562,19.468-22.5,18.307,8.2L345.923,33.06l1.815,1.366.394-9.3Z",
    transform: "translate(-280.861 -25.123)",
    fill: "#f48221"
  }))))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M355.561,75.258H289.281a1.666,1.666,0,1,1,0-3.332h66.281a1.666,1.666,0,1,1,0,3.332",
    transform: "translate(130.374 32.604)",
    fill: "#263238"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(417.99 104.53)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M355.561,75.258H289.281a1.666,1.666,0,1,1,0-3.332h66.281a1.666,1.666,0,1,1,0,3.332",
    transform: "translate(-287.615 -71.926)",
    fill: "#fff"
  }))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M84.845,301.313a51.842,51.842,0,1,0,43.24-59.206A51.841,51.841,0,0,0,84.845,301.313Z",
    transform: "translate(38.176 109.462)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M445.3,274.365a51.841,51.841,0,1,1-3.893-73.211A51.841,51.841,0,0,1,445.3,274.365Z",
    transform: "translate(160.879 85.158)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M279.9,85.988a51.842,51.842,0,1,0,34-64.954A51.842,51.842,0,0,0,279.9,85.988Z",
    transform: "translate(125.801 8.457)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M160.516,166.152A51.841,51.841,0,1,1,181.784,95.99,51.843,51.843,0,0,1,160.516,166.152Z",
    transform: "translate(38.175 31.089)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M240.013,202.749a30.9,30.9,0,1,1,43.347-5.566A30.9,30.9,0,0,1,240.013,202.749Z",
    transform: "translate(103.351 66.81)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "10.686 2.671 22.262 8.905"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 115.956,
    y1: 53.016,
    transform: "translate(218.682 178.233)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 93.15,
    x2: 54.002,
    transform: "translate(377.635 125.153)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 127.219,
    y2: 53.837,
    transform: "translate(390.096 258.522)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 123.5,
    y2: 105.957,
    transform: "translate(213.782 263.304)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M84.845,301.313a51.842,51.842,0,1,0,43.24-59.206A51.841,51.841,0,0,0,84.845,301.313Z",
    transform: "translate(38.176 109.462)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M445.3,274.365a51.841,51.841,0,1,1-3.893-73.211A51.841,51.841,0,0,1,445.3,274.365Z",
    transform: "translate(160.879 85.158)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M279.9,85.988a51.842,51.842,0,1,0,34-64.954A51.842,51.842,0,0,0,279.9,85.988Z",
    transform: "translate(125.801 8.457)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M160.516,166.152A51.841,51.841,0,1,1,181.784,95.99,51.843,51.843,0,0,1,160.516,166.152Z",
    transform: "translate(38.175 31.089)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "8.963 2.241 18.673 7.469"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M240.013,202.749a30.9,30.9,0,1,1,43.347-5.566A30.9,30.9,0,0,1,240.013,202.749Z",
    transform: "translate(103.351 66.81)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217,
    strokeDasharray: "10.686 2.671 22.262 8.905"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 115.956,
    y1: 53.016,
    transform: "translate(218.682 178.233)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 93.15,
    x2: 54.002,
    transform: "translate(377.635 125.153)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 127.219,
    y2: 53.837,
    transform: "translate(390.096 258.522)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 123.5,
    y2: 105.957,
    transform: "translate(213.782 263.304)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.217
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M305.768,146.951c-4.312.7-14.051,32.583-17.967,36.748-2.053,2.184-24.466-4.165-24.466-4.165l-2.645,8.233s24.517,10.119,31.192,7.657c11.179-4.123,16.71-27.134,16.71-27.134Z",
    transform: "translate(118.17 66.612)",
    fill: "#263238"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(378.867 213.557)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M308.6,168.3a77.118,77.118,0,0,1-3.343,10.071c-1.962,4.839-4.825,10.347-8.56,13.923a14.172,14.172,0,0,1-4.81,3.139c-6.671,2.456-31.188-7.659-31.188-7.659l2.63-8.24s22.424,6.351,24.473,4.171c3.909-4.171,13.661-36.056,17.963-36.754Z",
    transform: "translate(-260.695 -146.947)",
    fill: "#fff"
  }))))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M265.875,171.85l-8.5-7.666L253.044,174.3s9.127,5.915,11.506,3.482Z",
    transform: "translate(114.704 74.424)",
    fill: "#eec1bb"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M249.386,165.344l-1.182,7.813,7.032,1.142,4.326-10.115Z",
    transform: "translate(112.51 74.424)",
    fill: "#eec1bb"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M266.794,169.763,263.6,179.885l-4.081-1.806,2.9-9.5Z",
    transform: "translate(117.639 76.417)",
    fill: "#407bff"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(377.159 244.998)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M266.794,169.763,263.6,179.885l-4.081-1.806,2.9-9.5Z",
    transform: "translate(-259.52 -168.581)",
    fill: "#fff"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(414.795 234.761)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M294.047,171.754c-1.962,4.839-4.825,10.347-8.56,13.923-.916-13.458,7.543-24.139,7.543-24.139a33,33,0,0,1,1.017,10.217",
    transform: "translate(-285.417 -161.537)"
  }))))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M297.769,133.8c1.006,5.345,0,12.344,0,12.344s24.866,3.449,30.9-1.15,8.705-31.941-4.744-34.568S294.607,117,297.769,133.8",
    transform: "translate(134.793 49.857)",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M292.7,366.227l-2.081,0-.578-2.569-6.889,3.11H265.7s-2.776-2.79,5.537-5.014a6.267,6.267,0,0,0,1.177-.451c4.433-2.078,10.74-9.1,10.74-9.1h9.577a12.147,12.147,0,0,1,.785,1.381c1.046,2.107,2.854,6.53-.814,12.644",
    transform: "translate(120.238 159.652)",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M291.282,354.225v.029c-1.264-1.41-7.019,4.781-11.234,6.889-3.764,1.875-7.993,2.7-9.868.8,4.433-2.078,11.4-11.153,11.4-11.153h7.7s1.546,2.535,2,3.436",
    transform: "translate(122.471 159.011)",
    fill: "#ffc2bc"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M277.57,363.921l4.393-37.571,13.774,4.06-9.582,33.828",
    transform: "translate(125.821 147.933)",
    fill: "#ffc2bc"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M336.827,194.4l-37.633-1.767s-10.054,64.789-10.977,106.188c-2.944,27.774-6.429,75.217-9.808,104.258a19.036,19.036,0,0,0,7.155,2.673,19.918,19.918,0,0,0,6.326.3c8.7-24.927,18.95-66.246,18.249-106.2,26.563-64.57,26.688-105.45,26.688-105.45",
    transform: "translate(126.202 87.321)",
    fill: "#263238"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(404.605 279.959)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M336.827,194.4s-.058,22.948-11.263,61.591c-2.95,10.173-6.671,21.436-11.365,33.658q-1.918,4.992-4.055,10.2c.7,39.951-9.548,81.283-18.253,106.207a20.171,20.171,0,0,1-6.322-.305,19.13,19.13,0,0,1-7.165-2.674c3.386-29.037,6.874-76.472,9.81-104.259.93-41.39,10.987-106.178,10.987-106.178Z",
    transform: "translate(-278.405 -192.637)",
    fill: "#fff"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(439.612 325.316)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M314.646,241.839c-2.95,10.173-6.671,21.436-11.365,33.658-3.212-33,4.433-51.65,4.433-51.65,3.4,4.229,5.61,10.653,6.932,17.992",
    transform: "translate(-302.493 -223.847)"
  }))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M329.724,366.227l-2.081,0-.578-2.569-6.889,3.11H302.722s-2.776-2.79,5.537-5.014a6.267,6.267,0,0,0,1.177-.451c4.433-2.078,10.74-9.1,10.74-9.1h9.577a12.157,12.157,0,0,1,.785,1.381c1.046,2.107,2.854,6.53-.814,12.644",
    transform: "translate(137.021 159.652)",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M328.3,354.225v.029c-1.264-1.41-7.019,4.781-11.234,6.889-3.764,1.875-7.993,2.7-9.868.8,4.433-2.078,11.4-11.153,11.4-11.153h7.7s1.546,2.535,2,3.436",
    transform: "translate(139.254 159.011)",
    fill: "#ffc2bc"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M314.652,364.747l-.189-40.218,14.7.647-6.38,39.6Z",
    transform: "translate(142.545 147.107)",
    fill: "#ffc2bc"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M319.454,407.3a39.394,39.394,0,0,0,7.075,1.648,15.923,15.923,0,0,0,5.94-.233c6.707-28.3,13.562-73.91,5.868-101.37,14.677-88.738-4.79-112.466-4.79-112.466l-33.025-3.593s10.635,75.1,14.234,111.808c3.091,31.532,5.831,68.334,4.7,104.206",
    transform: "translate(136.225 86.708)",
    fill: "#263238"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(436.747 277.992)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M319.454,407.3a39.394,39.394,0,0,0,7.075,1.648,15.923,15.923,0,0,0,5.94-.233c6.707-28.3,13.562-73.91,5.868-101.37,14.677-88.738-4.79-112.466-4.79-112.466l-33.025-3.593s10.635,75.1,14.234,111.808c3.091,31.532,5.831,68.334,4.7,104.206",
    transform: "translate(-300.522 -191.284)",
    fill: "#fff"
  }))))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M331.877,144.347s-25.706,12.734-23.5,1.1c0,0-9.476-.089-15.709,3.72,0,0-3.7,15.478,0,57.085l-2.644,20.122,15.213,4.6,5.012-14.594,6.069,15.357,26.427-8.255-5.332-15.5s2.683-35.645,10.733-51.935c0,0-1.282-11.859-16.27-11.693",
    transform: "translate(131.467 65.431)",
    fill: "#407bff"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(421.493 209.776)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M331.877,144.347s-25.706,12.734-23.5,1.1c0,0-9.476-.089-15.709,3.72,0,0-3.38,16.706,0,57.085l-2.644,20.122,15.213,4.6,5.012-14.594,6.069,15.357,26.427-8.255-5.332-15.5s2.683-35.645,10.733-51.935c0,0-1.282-11.859-16.27-11.693",
    transform: "translate(-290.026 -144.345)",
    fill: "#fff"
  }))))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M325.47,129.114c-1.776,6.563-3.956,18.591.31,22.969,0,0,5.831,4.664-11.5,4.139-1.506,3.607-7.2,11.32-7.2,11.32s-2.646-7.312-1.443-9.941c-11.144-.962-.257-5.517-.257-5.517,7.45-1.748,7.666-7.178,6.771-12.279Z",
    transform: "translate(136.268 58.527)",
    fill: "#eec1bb"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(448.424 192.004)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M316.441,132.116l-7.883,6.323a20.548,20.548,0,0,1,.359,3.622c2.827-.4,6.9-3.473,7.41-6.4a9.786,9.786,0,0,0,.113-3.543",
    transform: "translate(-308.557 -132.116)"
  }))))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M331.442,125.255c-1.991,10.6-2.61,15.114-8.657,20.2-9.1,7.647-21.6,3.6-22.791-7.2-1.075-9.725,2.363-25.424,13.283-28.922,10.76-3.449,20.156,5.329,18.165,15.928",
    transform: "translate(135.901 49.212)",
    fill: "#eec1bb"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M315.332,116.814c5.85,7.547-6.163,16.226,5.85,15.723s7.131-17.464,0-21.321-5.85,5.6-5.85,5.6",
    transform: "translate(142.898 49.995)",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M310.68,121.795c-.129.9-.7,1.59-1.273,1.546s-.934-.8-.807-1.7.7-1.588,1.273-1.546.936.8.807,1.7",
    transform: "translate(139.875 54.437)",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M303.231,121.356c-.129.9-.7,1.59-1.273,1.546s-.934-.8-.807-1.7.7-1.59,1.273-1.548.936.8.807,1.7",
    transform: "translate(136.499 54.238)",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M302.82,119.944l-2.021-.776s.841,1.761,2.021.776",
    transform: "translate(136.35 54.018)",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M305.734,121.99a26.573,26.573,0,0,1-3.953,5.492c1,1.192,3.046.831,3.046.831Z",
    transform: "translate(136.796 55.298)",
    fill: "#d4827d"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M307.56,129.8a8.3,8.3,0,0,1-1.491.02.242.242,0,0,1-.221-.282.283.283,0,0,1,.3-.244,7.521,7.521,0,0,0,6.072-2.359.253.253,0,1,1,.391.318,7.914,7.914,0,0,1-5.047,2.546",
    transform: "translate(138.638 57.493)",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M313.471,118.748a.483.483,0,0,1-.371-.158,3.876,3.876,0,0,0-3.43-1.317.482.482,0,0,1-.58-.414.572.572,0,0,1,.452-.622,4.837,4.837,0,0,1,4.354,1.613.537.537,0,0,1-.061.747.546.546,0,0,1-.365.151",
    transform: "translate(140.107 52.665)",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M301.064,118.175a.484.484,0,0,1-.363-.118.522.522,0,0,1-.019-.738,5.532,5.532,0,0,1,4.485-2,.48.48,0,0,1,.42.578.57.57,0,0,1-.609.465,4.43,4.43,0,0,0-3.536,1.62.57.57,0,0,1-.378.19",
    transform: "translate(136.233 52.269)",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M310.269,120.383l-2.023-.776s.843,1.761,2.023.776",
    transform: "translate(139.726 54.217)",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M319.4,112.307s2.081,12.493,10.379,14.582,1.562-12.844,1.562-12.844-1.742-6.768-12.953-6.768-24.148,11.388-20.554,27.756c0,0-.616-5.464,1.869-9.769s5.042-.6,19.7-12.958",
    transform: "translate(134.729 48.628)",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M318.777,108.564c11.85,4.739,16.162,12.5,15.156,21.125s-11.642,17.751-13.367,18.075l-5.323.754s8.194-11.392,6.615-15.255-3.159-4.242-3.159-4.242Z",
    transform: "translate(142.898 49.212)",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M324.62,129.094a7.412,7.412,0,0,1-4.507,3.947c-2.466.655-3.536-2.173-2.715-5,.74-2.542,2.912-5.945,5.323-5.332,2.373.606,3.139,3.9,1.9,6.381",
    transform: "translate(143.752 55.592)",
    fill: "#eec1bb"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M325.307,144.678c-8.028,7.45-12.337,46.745-11.189,59.437s11.189,46.654,11.189,46.654l15.832-1.3s-3.831-23.561-13.6-42.342c0,0,6.224-46.7,11.974-58.315,0,0-5.451-2.16-7.139-2.651-1.865-.544-7.064-1.485-7.064-1.485",
    transform: "translate(142.305 65.582)",
    fill: "#263238"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(456.24 210.258)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M341.141,249.474,325.3,250.768s-3.357-11.35-6.395-23.384c-1.279-5.014-2.485-10.144-3.386-14.606a84.067,84.067,0,0,1-1.4-8.662c-.131-1.439-.189-3.241-.189-5.29.058-15.928,4.258-47.537,11.365-54.15,0,0,1.235.218,2.718.509,1.57.32,3.4.7,4.36.974,1.686.494,7.136,2.66,7.136,2.66a43.577,43.577,0,0,0-2.34,6.395c-.218.77-.451,1.584-.669,2.427-2.529,9.432-4.912,22.948-6.6,33.469-1.453,9.141-2.369,16.015-2.369,16.015,1.032,1.991,2.006,4.026,2.892,6.089,7.644,17.425,10.711,36.26,10.711,36.26",
    transform: "translate(-313.935 -144.677)",
    fill: "#fff"
  }))))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M325.25,144.678s6.2,12.767,4.764,25.847l-9.346-7.329,5.322,6.9-11.929,21.847s.962-39.047,11.189-47.264",
    transform: "translate(142.362 65.582)",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M306.783,145.137s-9.67,16.554-7.947,59.1l-5.749,43.121h-6.323l7.034-43.121s-7.513-32.579.153-56.463a37.473,37.473,0,0,1,12.833-2.636",
    transform: "translate(129.989 65.79)",
    fill: "#263238"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(416.751 210.927)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M306.783,145.137s-9.67,16.554-7.947,59.1l-5.749,43.121h-6.323l7.034-43.121s-7.513-32.579.153-56.463a37.473,37.473,0,0,1,12.833-2.636",
    transform: "translate(-286.763 -145.137)",
    fill: "#fff"
  }))))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M306.556,145.213s-1.488-.818-4.837.538-11.4,19.083-11.4,19.083l6.133-3.545-3.45,3.545,4.168,21.268s4.63-38.28,9.382-40.888",
    transform: "translate(131.602 65.714)",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M312.145,143.1s-5.717,3.985-5.033,8.168l-9.75,2.4s5.765-9.875,14.783-10.568",
    transform: "translate(134.793 64.864)",
    fill: "#407bff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M323.761,155.751l-13.646-4.433s7.223-5.828,9.476-8.981l4.505,3.386.015.015c.1.247,1.439,3.561-.349,10.013",
    transform: "translate(140.574 64.521)",
    fill: "#407bff"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(432.155 207.959)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M312.145,143.1s-5.717,3.985-5.033,8.168l-9.75,2.4s5.765-9.875,14.783-10.568",
    transform: "translate(-297.362 -143.095)",
    fill: "#fff"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(450.689 206.858)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M323.761,155.751l-13.646-4.433s7.223-5.828,9.476-8.981l4.505,3.386.015.015c.1.247,1.439,3.561-.349,10.013",
    transform: "translate(-310.115 -142.337)",
    fill: "#fff"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(441.809 256.691)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M334.931,198.732c-.639.015-1.308.015-1.991.015-3.924-.015-8.545-.2-12.92-.451-8.444-.48-16.015-1.148-16.015-1.148l.625-10.536,8.458.116.421-.785a35.333,35.333,0,0,0,4.927-1.6,150.178,150.178,0,0,0,14.4-6.86c.581-.32,1.1-.61,1.569-.857-1.453,9.141-2.369,16.015-2.369,16.015,1.032,1.991,2.006,4.026,2.892,6.089",
    transform: "translate(-304.005 -176.627)"
  }))))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M340.7,147.523c5.078,4.479,14.117,44.959,11.179,50.1s-37.267,10.99-37.267,10.99l-3.3-8.72s27.19-7.5,27.19-10.468c0-2.863-4.754-14.994-4.754-14.994s-1.094-13.824,2.739-20.6a37.143,37.143,0,0,1,4.216-6.307",
    transform: "translate(141.115 66.872)",
    fill: "#263238"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(452.424 214.395)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M340.7,147.523c5.078,4.479,14.117,44.959,11.179,50.1s-37.267,10.99-37.267,10.99l-3.3-8.72s27.19-7.5,27.19-10.468c0-2.863-4.754-14.994-4.754-14.994s-1.094-13.824,2.739-20.6a37.143,37.143,0,0,1,4.216-6.307",
    transform: "translate(-311.309 -147.523)",
    fill: "#fff"
  }))))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M315.368,184.547,304.01,183.1l2.218,10.775s10.871-.35,11.436-3.707Z",
    transform: "translate(137.806 83.001)",
    fill: "#eec1bb"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M298.713,189.864l3.488,7.091,6.426-3.075-2.218-10.775Z",
    transform: "translate(135.405 83.001)",
    fill: "#eec1bb"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M315.3,182.53l3.154,10.134-4.382.846-3.04-9.454Z",
    transform: "translate(140.988 82.74)",
    fill: "#407bff"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(452.017 265.27)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M315.3,182.53l3.154,10.134-4.382.846-3.04-9.454Z",
    transform: "translate(-311.029 -182.53)",
    fill: "#fff"
  }))))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M236.453,197.989l6.857,13.144-14.081,2.149s-4.46-13.356-.639-15.552Z",
    transform: "translate(102.917 89.63)",
    fill: "#ffb573"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M238.143,219.336l-10.177-1.048.844-9.186,14.081-2.149Z",
    transform: "translate(103.336 93.811)",
    fill: "#ffb573"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M235.892,193.431l3.129,8.077-11.368,2.811L224.4,196.3Z",
    transform: "translate(101.721 87.681)",
    fill: "#407bff"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(326.122 281.112)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M235.892,193.431l3.129,8.077-11.368,2.811L224.4,196.3Z",
    transform: "translate(-224.402 -193.431)",
    fill: "#fff"
  }))))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M213.547,126.557c-3.85,3.813-.217,50.73-.1,56.33s16.543,47.107,16.543,47.107l13.261-4.072L229.69,182.647c-1.978-6.31-1.586-22.469-1.732-29.332-.116-5.329-.408-13.71-4.183-18.614s-10.228-8.144-10.228-8.144",
    transform: "translate(96 57.368)",
    fill: "#263238"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(307.782 183.925)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M213.547,126.557c-3.85,3.813-.217,50.73-.1,56.33s16.543,47.107,16.543,47.107l13.261-4.072L229.69,182.647c-1.978-6.31-1.586-22.469-1.732-29.332-.116-5.329-.408-13.71-4.183-18.614s-10.228-8.144-10.228-8.144",
    transform: "translate(-211.782 -126.557)"
  }))))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M237.366,165.335l14.329-3.8-1,14.209s-14.011,1.413-15.312-2.8Z",
    transform: "translate(106.698 73.224)",
    fill: "#ffb573"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M257.956,168.895l-3.261,9.7-8.775-2.846,1-14.209Z",
    transform: "translate(111.474 73.225)",
    fill: "#ffb573"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M227.107,143.879l-1.341-13.989c-2.322-.4-3.537-4.662-6.153-4.9-6.6-.591-17.456-.355-24.947,0-2.475.118-4.975.343-7.325.609l-7.416,29.784c.949,8.188,1.509,16.123,1.815,23.514.9,21.72-.311,25.687.1,30.929h58.7c-1.915-34.475-3.7-54.8-4.883-65.942Z",
    transform: "translate(81.559 56.492)",
    fill: "#407bff"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(261.849 181.116)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M226.992,143.879l-1.341-13.989c-2.322-.4-3.537-4.662-6.153-4.9-6.6-.591-17.456-.355-24.947,0-1.551.074-3.113.19-4.642.333l-9.733,33.51c.722,6.961,1.186,13.719,1.449,20.064.9,21.72-.311,25.687.1,30.929h58.7c-1.642-34.219-3.485-54.69-4.76-65.942Z",
    transform: "translate(-180.176 -124.624)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(280.758 183.404)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M211.536,127.936a44.529,44.529,0,0,0-3.643,4.418l-.718,6.756s10.233,30.39,11.026,44.522l-3.747,3.587-6.562-5.707a381.325,381.325,0,0,0-2.939-42.33l-2.481-6s-6.379-2.76-9.05-5.77,18.112.525,18.112.525",
    transform: "translate(-193.187 -126.199)",
    fill: "#c15200"
  }))))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M190.9,107.533l6.678,5.537,9.09,7.551a29.47,29.47,0,0,0-.578,3.672c-.488,4.928,1.161,6.352,6.213,8.236,0,0,.222,3.132-3.055,6.633-.038.805-2.177,2.1-2.177,2.1a14.613,14.613,0,0,0-1.857-1.751c-13.965-.249-15.809-6.72-15.809-6.72,5.434-5.358,3.345-17.219,1.5-25.258",
    transform: "translate(85.856 48.744)",
    fill: "#ffb573"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(283.385 161.814)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M204.134,118.894a29.825,29.825,0,0,0-.578,3.672c-3.389-.682-7.92-4.294-8.394-7.758a15.81,15.81,0,0,1-.118-3.465Z",
    transform: "translate(-194.995 -111.343)"
  }))))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M213.437,87.375s5.964,14.175-.429,21.821-13.322-19.8-13.322-19.8Z",
    transform: "translate(90.517 39.607)",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M197.749,126.766a13.8,13.8,0,0,0,16.672,1.305,15.621,15.621,0,0,0,7.107-10.669c1.575-9.981-1.18-26.047-12.2-29.548a14.965,14.965,0,0,0-19.394,16.523c1.49,10.827,1.856,17.264,7.811,22.389",
    transform: "translate(86.018 39.49)",
    fill: "#ffb573"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M201.428,100.726c.007.884.589,1.567,1.177,1.52s.99-.809.927-1.693-.6-1.567-1.179-1.52-.99.795-.926,1.693",
    transform: "translate(91.303 44.89)",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M208.329,100.184c.007.884.6,1.567,1.177,1.52s.99-.808.927-1.692-.6-1.568-1.179-1.52-.99.85-.926,1.692",
    transform: "translate(94.432 44.645)",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M206.158,100.128a31.673,31.673,0,0,0,4.834,7.258,5.157,5.157,0,0,1-4.2,1.131Z",
    transform: "translate(93.451 45.388)",
    fill: "#ed893e"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M212.2,97.163a.548.548,0,0,1-.546,0,4.21,4.21,0,0,0-3.752-.411.519.519,0,0,1-.446-.937h0a5.18,5.18,0,0,1,4.736.456.519.519,0,0,1,.193.709l-.007.01a.8.8,0,0,1-.179.179",
    transform: "translate(93.903 43.261)",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M200,98.327a.5.5,0,0,1-.3-.077.518.518,0,0,1-.019-.734l.007-.009a5.179,5.179,0,0,1,4.5-1.588.519.519,0,0,1,.405.612.532.532,0,0,1-.612.407,4.209,4.209,0,0,0-3.545,1.315.537.537,0,0,1-.44.074",
    transform: "translate(90.449 43.457)",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M198.606,89.21l1.2,1.937c-3.434,1.623-2.2,5.69-1.238,7.48,2.051,3.825.559,10.349-2.21,13.225,0,0-.315-1.729-1.732-1.131s-.038,8.089-.038,8.089-1.243,2.126-4.9-7.085c-3.377-8.518-4.588-15.821-3.21-19.455Z",
    transform: "translate(84.28 40.438)",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M187.325,107.663a10.4,10.4,0,0,0,6.352,4.776c3.537.886,5.207-2.3,4.152-5.6-.966-2.917-3.962-6.993-7.477-6.383s-4.712,4.273-3.027,7.2",
    transform: "translate(84.572 45.51)",
    fill: "#ffb573"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M208.941,108.586a32.8,32.8,0,0,0-2.229,4.178c-.27-.067-.541-.134-.808-.215-3.646-1-5.009-2.664-5.413-4.21a4.866,4.866,0,0,1,.01-2.308,4.7,4.7,0,0,1,.452-1.241c1.618,1.684,4.947,2.875,6.751,3.437.753.243,1.238.359,1.238.359",
    transform: "translate(90.82 47.501)",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M207.658,108.227l-.689,1.215c-3.433-.948-5.723-2.075-6.514-3.411a4.7,4.7,0,0,1,.452-1.241c1.618,1.684,4.947,2.875,6.751,3.437",
    transform: "translate(90.865 47.501)",
    fill: "#fff"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M205.862,111.442c-3.648-1-5.01-2.664-5.414-4.21a12.165,12.165,0,0,1,3.829,1.91,4.559,4.559,0,0,1,1.584,2.3",
    transform: "translate(90.862 48.608)",
    fill: "#de5753"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M218.122,94.147s3.646-4.142,2.846-9.223c0,0-20.913-3.6-30.439,0s-3.626,19.108-3.626,19.108,9.817-8.1,13.285-10.218,14.252,1.695,14.252,1.695Z",
    transform: "translate(83.903 37.77)",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M193.093,120.792s2.665,7.043,12.91,12.022l2.754,2.54-4.581-1.166-4.658,5.871-12.946-12.965s4.255-6.222,6.521-6.3",
    transform: "translate(84.572 54.754)",
    fill: "#407bff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M202.233,135.042l.74-4.049s.6-4.51-1.01-7.646c0,0-.637-.142-1-1.867l1.724.437s9.151,3.593,10.471,15.475l-7.264-5.039Z",
    transform: "translate(91.096 55.066)",
    fill: "#407bff"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(292.061 176.546)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M202.233,135.042l.74-4.049s.6-4.51-1.01-7.646c0,0-.637-.142-1-1.867l1.724.437s9.151,3.593,10.471,15.475l-7.264-5.039Z",
    transform: "translate(-200.965 -121.48)",
    fill: "#fff"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(271.144 175.546)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M193.093,120.792s2.665,7.043,12.91,12.022l2.754,2.54-4.581-1.166-4.658,5.871-12.946-12.965s4.255-6.222,6.521-6.3",
    transform: "translate(-186.572 -120.792)",
    fill: "#fff"
  }))))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M218.048,362.732l12.349,1.295.623-7.157,1.69-19.474-12.349-1.309L218.489,357.6Z",
    transform: "translate(98.84 152.346)",
    fill: "#9f5b53"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M175.636,361.89H187.6l.106-2.71.016-.334.609-17.358.015-.35.244-6.655H176.61Z",
    transform: "translate(79.615 151.619)",
    fill: "#9f5b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(317.328 488.431)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M220.224,336.085,218.351,357.6l12.532-.731,1.69-19.474Z",
    transform: "translate(-218.351 -336.085)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(255.327 493.715)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M175.688,357.993h.016l11.982-1.523h.016l.623-16.749h-.015l-12,.959-.609,16.788Z",
    transform: "translate(-175.688 -339.721)"
  }))))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M190.615,352.846H176.073a1.051,1.051,0,0,0-1.02.823l-2.36,10.659a1.766,1.766,0,0,0,1.363,2.093,1.744,1.744,0,0,0,.388.039c4.706-.077,8.131-.366,14.039-.366,3.639,0,14.617.381,19.643.381s5.68-4.963,3.623-5.421c-9.227-2.01-16.169-4.8-19.124-7.445a2.889,2.889,0,0,0-2.01-.762",
    transform: "translate(78.264 159.943)",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M233.047,352.584H218.505a1.05,1.05,0,0,0-1.02.823l-2.36,10.659a1.765,1.765,0,0,0,1.363,2.093,1.744,1.744,0,0,0,.388.039c4.7-.077,8.131-.366,14.039-.366,3.639,0,14.617.381,19.643.381s5.679-4.963,3.623-5.421c-9.227-2.01-16.171-4.8-19.124-7.445a2.889,2.889,0,0,0-2.01-.762",
    transform: "translate(97.498 159.825)",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M174.582,425.874H191.92s13.952-52.885,19.474-90.947c.872-5.915,1.788-13.661,2.718-22.7,1.482-14.591,2.979-32.089,4.331-48.947,4.142,11.132,7.3,27.06,9.737,45.11,8.676,64.7,7.8,115.958,7.8,115.958H253.54c11.278-86.093.669-173.6-6.685-219.026-1.5-9.214-2.863-16.684-3.88-22.076h-58.7c-.015,1.221.392,10.129.916,23.151,1.177,29.647,2.863,80.614,1.09,110.32-1.526,25.811-11.7,109.157-11.7,109.157",
    transform: "translate(79.137 83.065)",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M232.607,355a13.677,13.677,0,0,1-2.9.529.256.256,0,0,1-.246-.131.26.26,0,0,1,.02-.278c.259-.34,2.558-3.319,4-3.232a.956.956,0,0,1,.791.5,1.405,1.405,0,0,1,.124,1.42,2.963,2.963,0,0,1-1.78,1.187m-2.349-.041c1.988-.234,3.344-.738,3.675-1.381a.921.921,0,0,0-.11-.926.452.452,0,0,0-.379-.254c-.773-.046-2.225,1.4-3.186,2.561",
    transform: "translate(103.998 159.51)",
    fill: "#c15200"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M229.994,356.025a.252.252,0,0,1-.314-.144c-.052-.123-1.26-3.05-.536-4.408a1.281,1.281,0,0,1,.921-.674.981.981,0,0,1,1.12.451c.61,1.061-.24,3.745-1.078,4.7a.245.245,0,0,1-.113.074m.054-4.694a.759.759,0,0,0-.453.384c-.433.809.041,2.556.391,3.539.658-1.061,1.158-3.053.757-3.75-.076-.132-.211-.275-.578-.2-.041.009-.08.019-.116.03",
    transform: "translate(103.765 159.003)",
    fill: "#c15200"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M190.175,355a13.676,13.676,0,0,1-2.9.529.255.255,0,0,1-.246-.131.26.26,0,0,1,.02-.278c.259-.34,2.558-3.319,4-3.232a.956.956,0,0,1,.791.5,1.405,1.405,0,0,1,.124,1.42,2.963,2.963,0,0,1-1.78,1.187m-2.349-.041c1.988-.234,3.344-.738,3.675-1.381a.921.921,0,0,0-.11-.926.452.452,0,0,0-.379-.254c-.773-.046-2.225,1.4-3.186,2.561",
    transform: "translate(84.764 159.51)",
    fill: "#c15200"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M187.561,356.025a.251.251,0,0,1-.314-.144c-.052-.123-1.26-3.05-.536-4.408a1.281,1.281,0,0,1,.921-.674.981.981,0,0,1,1.121.451c.61,1.061-.24,3.745-1.078,4.7a.245.245,0,0,1-.113.074m.054-4.694a.759.759,0,0,0-.453.384c-.433.809.041,2.556.391,3.539.658-1.061,1.158-3.053.757-3.75-.076-.132-.211-.275-.578-.2-.041.009-.08.019-.116.03",
    transform: "translate(84.531 159.003)",
    fill: "#c15200"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(297.578 322.629)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M204.761,245.706c4.146,11.144,7.3,27.06,9.739,45.12,5.9-24.154-8.208-68.828-8.208-68.828Z",
    transform: "translate(-204.761 -221.998)"
  }))))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M241.639,195.047l-.936-14.79H182.715s-1.806,3.476-1.618,13.469Z",
    transform: "translate(82.084 81.71)",
    fill: "#263238"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    width: 6.21,
    height: 4.287,
    transform: "translate(317.513 263.834)"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    width: 26.199,
    height: 4.287,
    transform: "translate(289.568 263.834)"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1289",
    "data-name": "Rectangle 1289",
    width: 22.705,
    height: 4.287,
    transform: "translate(265.117 263.834)"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(263.413 266.311)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M181.252,183.246c-.015,1.221.392,10.129.916,23.151,11.2,2.892,36.042,1.933,36.042,1.933l2.3-1.758.857,1.758,22.468-3.008c-1.5-9.214-2.863-16.684-3.88-22.076Z",
    transform: "translate(-181.252 -183.246)"
  }))))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M207.473,186.211h5.505a.8.8,0,0,0,.794-.794v-3.282a.794.794,0,0,0-.794-.794h-5.505a.793.793,0,0,0-.794.794v3.282a.794.794,0,0,0,.794.794",
    transform: "translate(93.687 82.202)",
    fill: "#fff"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M222.476,218.859a71.208,71.208,0,0,1-2.456,12.673l-39.66-1.163s.785-31.231,1.119-43.933c.131-4.81-.741-14.4-1.86-24.444-.7-6.336-1.511-12.847-2.238-18.471a12.1,12.1,0,0,1-.116-1.25,17.422,17.422,0,0,1,13.545-17.992L219.948,169.3l.073.116s.2,1.075.494,2.979c.61,3.895,1.628,11.234,2.209,19.91a154.776,154.776,0,0,1-.247,26.552",
    transform: "translate(80.34 56.335)",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M189.1,123.3l-3.641,1.533,1.623,10.451,6.762,5.8-2.126,7.419L216.3,169.867s-19.509-29.777-27.2-46.569",
    transform: "translate(84.066 55.89)",
    fill: "#263238"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(269.519 179.188)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M189.1,123.3l-3.641,1.533,1.623,10.451,6.762,5.8-2.126,7.419L216.3,169.867s-19.509-29.777-27.2-46.569",
    transform: "translate(-185.454 -123.298)",
    fill: "#fff"
  }))))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M234.059,228.5l-23.267,1.584L209.7,218.7v-.015l-2.6-27.264-1.686-17.658c.262-.654.523-1.293.756-1.933.363-.916.7-1.8,1-2.689,11.466-32.016-.916-44.514-.916-44.514a24.6,24.6,0,0,1,16.4,7.609c4.273,9.432,7.714,25.424,8.077,42.064.2,9.214.087,17.323-.015,21.887-.044,2.485-.1,3.924-.1,3.924Z",
    transform: "translate(93.114 56.494)",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M206.257,124.624s9.207,4.518,12.831,12.742L217,140.087l4.505,7.621-16.1,26.058s6.934-39.527.846-49.142",
    transform: "translate(93.112 56.492)",
    fill: "#263238"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    transform: "translate(298.523 181.116)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M206.257,124.624s9.207,4.518,12.831,12.742L217,140.087l4.505,7.621-16.1,26.058s6.934-39.527.846-49.142",
    transform: "translate(-205.411 -124.624)",
    fill: "#fff"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(257.604 198.606)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M243.482,190.736c-5.174-.785-13.094-2.122-20.768-4.04-.959-.218-1.9-.465-2.848-.727a76.215,76.215,0,0,1-12.266-4.244c-9.839-4.636-21.828-17.948-27.99-25.345-.7-6.336-1.511-12.847-2.238-18.471a12.1,12.1,0,0,1-.116-1.25h15.2s22.41,27.191,26.479,29.72a2.2,2.2,0,0,0,.334.16,10.546,10.546,0,0,0,1.235.247c4.084.639,15.652,1.54,22.991,2.064.2,9.214.087,17.323-.015,21.887",
    transform: "translate(-177.255 -136.659)"
  }))))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M233.11,163.192l8.622.828-2.587,11.419-8.624-.69Z",
    transform: "translate(104.495 73.974)",
    fill: "#407bff"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(335.015 237.166)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M233.11,163.192l8.622.828-2.587,11.419-8.624-.69Z",
    transform: "translate(-230.521 -163.192)",
    fill: "#fff"
  }))))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M178.1,132.58c-6.9,20.785,22.283,43.4,29.593,49.377s50.708,8.492,50.708,8.492l2.285-13.657s-39.524-4.507-42.425-6.413-21.783-25.563-26.662-33.044-13.5-4.755-13.5-4.755",
    transform: "translate(80.258 59.878)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy);
export default __webpack_public_path__ + "static/media/why.99d6134a23399d279ff2bad060e7232d.svg";
export { ForwardRef as ReactComponent };